<div class="">
  <div class="" style="position: relative">
    <div class="card card-w-title" *ngIf="organisationTypeId == 0">Load user data...</div>
    <div class="card card-w-title" *ngIf="jobInfo == null && organisationTypeId != 0">
      Load job info...
    </div>
    <div class="card card-w-title" *ngIf="jobInfo != null && isAccessDenied">Access Denied</div>
    <div class="" *ngIf="jobInfo != null && !isAccessDenied">
      <div id="job-screen-header-bar" class="flex flex-wrap header-bar">
        <div class="incident-icons" *ngIf="jobInfo?.priorityDeployment">
          <i
            pTooltip="Priority Deployment Job"
            class="fa fa-exclamation-circle"
            style="color: #c00"
          ></i>
        </div>

        <div class="flex-shrink-1" *ngIf="organisationTypeId != 2">
          <h1>Job: {{ jobInfo?.jobNumber }} &nbsp;</h1>
        </div>

        <div class="flex-shrink-1" *ngIf="organisationTypeId == 2">
          <h1>Order: {{ selectedOrder?.orderNumber }} &nbsp;</h1>
        </div>
        <div class="flex-shrink-1" *ngIf="organisationTypeId != 2">
          <h1>Status:{{ getStatus() }} &nbsp;</h1>
        </div>

        <div *ngIf="organisationTypeId != 2" class="flex-grow-1">
          <button
            pButton
            label="Back"
            class="red-btn pull-right mt-1"
            (click)="onClickBack()"
          ></button>

          <button
            *ngIf="canShowPriceDetails()"
            class="pull-right mt-1"
            type="button"
            (click)="showPriceDetails()"
            label="Price Details"
            pButton
          ></button>

          <button
            *ngIf="canDeploy()"
            class="pull-right mt-1"
            type="button"
            (click)="deployJob()"
            label="Deploy"
            pButton
          ></button>

          <button
            *ngIf="canDeploy()"
            class="pull-right mt-1"
            type="button"
            (click)="deployJobToSupplier()"
            label="Deploy Supplier"
            pButton
          ></button>

          <button
            *ngIf="canDeploy()"
            icon="fa fa-thumb-tack"
            class="pull-right mt-1"
            type="button"
            (click)="markPriority()"
            label="Mark/Unmark for Priority Deployment"
            pButton
          ></button>

          <button
            *ngIf="organisationId == 1 && (telephonyService.AnonCallLoggable$ | async)"
            class="pull-right mt-1"
            type="button"
            (click)="logCall()"
            label="Log Call"
            pButton
          ></button>

          <!--          <button-->
          <!--            *ngIf="organisationTypeId == 1 && callerInfo && jobAssociatedWithCall"-->
          <!--            class="pull-right mt-1"-->
          <!--            type="button"-->
          <!--            (click)="disassociateJobFromCall()"-->
          <!--            label="Unlink Job From This Call"-->
          <!--            pButton-->
          <!--          ></button>-->

          <div *ngIf="organisationTypeId == 1" class="customer-information pull-right">
            <p-splitButton
              label="Customer Information"
              icon="pi pi-external-link"
              (onClick)="linkToCustomerInfo(null)"
              [model]="customerLinkData"
              styleClass="mt-1 ui-widget ui-state-default ui-corner-all ui-button-secondary"
            >
            </p-splitButton>
          </div>
        </div>
        <div *ngIf="organisationTypeId == 2" class="flex-grow-1">
          <button
            pButton
            label="Back"
            class="red-btn pull-right mt-1"
            (click)="onClickBack()"
          ></button>

          <button
            *ngIf="
              (jobInfo?.statusId == jobStatus_Closed || jobInfo?.statusId == jobStatus_Cancelled) &&
              !hasCustomerBookingRole &&
              !hasCustomerPriceRole
            "
            class="pull-right mt-1"
            type="button"
            (click)="showPriceDetails()"
            label="Price Details"
            pButton
          ></button>
        </div>
      </div>
      <div class="content-container">
        <div
          class="ui-g job-confirmation-status"
          *ngIf="jobInfo?.confirmed && organisationTypeId == 1"
        >
          <div class="verification-image-div">
            <img src="{{ verifiedImageUrl }}" alt="note" />
            <span
              ><i
                >Job verified by {{ jobInfo?.confirmedByUser }} on {{ getConfirmedDateTime() }}</i
              ></span
            >
            <span *ngIf="jobInfo?.notes != null && jobInfo?.notes != ''" class="verification-notes"
              ><strong>Notes:</strong> {{ jobInfo?.notes }}</span
            >
          </div>
        </div>
        <div
          class="card card-w-title"
          *ngIf="
            organisationTypeId == 1 ||
            organisationTypeId == 2 ||
            ((organisationTypeId == 3 || organisationTypeId == 4) &&
              jobInfo?.supplierId == organisationId)
          "
        >
          <div
            (click)="scrollTo('details-section')"
            class="delay-banner-notification"
            *ngIf="organisationTypeId == 1 && tasksRequireFailureReason"
          >
            <span>Job failed and cannot auto-close:</span>
            <span style="margin-left: 10px"
              >One or more tasks require a delay/failure notification</span
            >
          </div>
          <h2 class="sub-header-bar">Job information</h2>
          <div
            *ngIf="organisationTypeId == 1"
            style="margin-bottom: 20px"
            class="progress-bar-container"
          >
            <progress-bar [currentStep]="jobTimelineCurrentStep" [steps]="jobTimelineSteps">
              <ng-template #titleTemplate let-item="item">
                <div style="padding-left: 5px; padding-right: 5px">
                  <div style="width: 100%">
                    <div
                      class="progress-step-item-title job-information-title"
                      [class.customer-info]="item.isCustomer"
                      [class.system-info]="!item.isCustomer"
                    >
                      <span>{{ item.name }}</span>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template #lineTemplate let-item="item" let-i="i" let-length="length">
                <div class="custom-left-progress" *ngIf="i > 0"></div>
                <div class="custom-right-progress" *ngIf="i < length - 1"></div>
                <span class="custom-progress-step-item-number"></span>
              </ng-template>
              <ng-template #dateTemplate let-item="item">
                <span class="progress-step-item-date job-information-date" *ngIf="item.date">{{
                  item.date | datex : "ddd DD MMM 'YY"
                }}</span>
                <hr class="no-border" />
                <span class="progress-step-item-date job-information-date" *ngIf="item.date">{{
                  item.date | datex : 'HH:mm'
                }}</span>
              </ng-template>
            </progress-bar>
          </div>

          <div *ngIf="jobInfo && organisationTypeId != 2">
            <div class="job-data-flex-wrapper">
              <div class="job-data-flex-left">
                <div class="job-data-left">
                  <p-panel
                    *ngIf="organisationTypeId == 1"
                    header="Dates & Prices"
                    [style]="{ height: '100%' }"
                  >
                    <div class="ui-g" style="height: 100%">
                      <div class="ui-g-12">
                        <div class="ui-grid-col-7 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Released from hold</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.heldEndDate | datex : "ddd DD MMM 'YY HH:mm" }}
                          </div>
                        </div>
                        <div class="ui-grid-col-5 ui-sm-12">
                          <div class="ui-grid-col-8 bold">Existing capacity</div>
                          <div class="ui-grid-col-4">
                            {{
                              jobInfo?.existingCapacityPrice | currency : 'GBP' : 'symbol' : '1.2-2'
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-7 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Existing capacity end</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.exisingCapacityEndDate | datex : "ddd DD MMM 'YY HH:mm" }}
                          </div>
                        </div>

                        <div class="ui-grid-col-5 ui-sm-12">
                          <div class="ui-grid-col-8 bold">Customer Premium</div>
                          <div
                            class="ui-grid-col-4 showPremiums"
                            (click)="
                              showCustomerPremiums = !showCustomerPremiums;
                              showSupplierPremiums = false
                            "
                            id="customerPremium"
                          >
                            {{ jobInfo?.customerPremium | currency : 'GBP' : 'symbol' : '1.2-2' }}
                            <span style="position: relative" *ngIf="jobInfo.customerPremium > 0">
                              <i class="fa fa-info-circle"></i>
                              <div *ngIf="showCustomerPremiums" class="hover-tip">
                                <div *ngFor="let pp of jobInfo.customerPremiumSummary">
                                  {{ pp.premium | currency : 'GBP' : 'symbol' : '1.2-2' }} -
                                  {{ pp.categoryName }}
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-7 ui-sm-12">&nbsp;</div>
                        <div class="ui-grid-col-5 ui-sm-12">
                          <div class="ui-grid-col-8 bold">Supplier Reserve Price</div>
                          <div class="ui-grid-col-4">
                            {{
                              jobInfo?.auctionReservePrice | currency : 'GBP' : 'symbol' : '1.2-2'
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-7 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Grab it now opens</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.exisingCapacityEndDate | datex : "ddd DD MMM 'YY HH:mm" }}
                          </div>
                        </div>
                        <div class="ui-grid-col-5 ui-sm-12">
                          <div class="ui-grid-col-8 bold">Grab it now</div>
                          <div class="ui-grid-col-4">
                            {{ jobInfo?.buyItNowPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                          </div>

                          <div
                            *ngIf="
                              jobInfo?.buyItNowPriceOriginal > 0 &&
                              jobInfo?.buyItNowPriceOriginal != jobInfo?.buyItNowPrice
                            "
                          >
                            <div style="padding-top: 5px; font-size: 12px">
                              (Original Grab It Now
                              {{
                                jobInfo?.buyItNowPriceOriginal
                                  | currency : 'GBP' : 'symbol' : '1.2-2'
                              }})
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-7 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Collection Scheduled Date</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.scheduledDate | datex : "ddd DD MMM 'YY" }}
                          </div>
                        </div>

                        <div class="ui-grid-col-5 ui-sm-12">
                          <div class="ui-grid-col-8 bold">Supplier Price</div>
                          <div class="ui-grid-col-4">
                            {{
                              (jobInfo?.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2') ||
                                'N/A'
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-7 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Delivery Scheduled Date</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.scheduledDate | datex : "ddd DD MMM 'YY" }}
                          </div>
                        </div>
                        <div class="ui-grid-col-5 ui-sm-12">
                          <div class="ui-grid-col-8 bold">Supplier Premium</div>
                          <div
                            class="ui-grid-col-4 showPremiums"
                            (click)="
                              showSupplierPremiums = !showSupplierPremiums;
                              showCustomerPremiums = false
                            "
                          >
                            {{ jobInfo?.supplierPremium | currency : 'GBP' : 'symbol' : '1.2-2' }}
                            <span style="position: relative" *ngIf="jobInfo.supplierPremium > 0">
                              <i class="fa fa-info-circle"></i>
                              <div *ngIf="showSupplierPremiums" class="hover-tip">
                                <div *ngFor="let pp of jobInfo.supplierPremiumSummary">
                                  {{ pp.premium | currency : 'GBP' : 'symbol' : '1.2-2' }} -
                                  {{ pp.categoryName }}
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-7 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Insurance Provider</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.insuranceProviderName }}
                          </div>
                        </div>
                        <div class="ui-grid-col-5 ui-sm-12">
                          <div class="ui-grid-col-8 bold">Insurance Cost</div>
                          <div class="ui-grid-col-4">
                            {{ jobInfo?.insuranceCost | currency : 'GBP' : 'symbol' : '1.2-2' }}
                          </div>
                        </div>
                      </div>

                      <div class="ui-g-12">
                        <button
                          pButton
                          label="Change"
                          (click)="showChangeJobDetails()"
                          [disabled]="organisationTypeId != 1 || isJobClosed(jobInfo)"
                          data-test-id="change-job-details-btn"
                        ></button>
                        <button
                          pButton
                          label="Release from Hold"
                          (click)="releaseFromHold()"
                          [disabled]="organisationTypeId != 1 || !isJobHeld()"
                          data-test-id="release-from-hold-btn"
                        ></button>
                      </div>
                    </div>
                  </p-panel>
                </div>

                <div *ngIf="jobInfo?.supplier != null" class="job-data-left">
                  <p-panel
                    *ngIf="jobInfo?.supplierId == organisationId || organisationTypeId == 1"
                    header="Supplier Information"
                    [style]="{ height: '100%' }"
                  >
                    <div class="ui-g" style="height: 100%; margin-bottom: 0px">
                      <div class="ui-g-12">
                        <div class="ui-grid-col-6 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Name</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.supplier?.name || '' }}
                          </div>
                        </div>
                        <div class="ui-grid-col-6 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Supplier Price</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-6 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Telephone Number</div>
                          <div class="ui-grid-col-7">
                            <a href="tel:{{ jobInfo?.supplier?.phoneNumber || '' }}">
                              {{ jobInfo?.supplier?.phoneNumber || '' }}
                            </a>
                          </div>
                        </div>
                        <div class="ui-grid-col-6 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Account code</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.accountCodeList?.code || '' }}
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-6 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Postcode</div>
                          <div class="ui-grid-col-7">{{ jobInfo?.supplier?.postcode || '' }}</div>
                        </div>
                        <div class="ui-grid-col-5 bold">Tags</div>
                        <div class="ui-grid-col-7">
                          <div *ngIf="jobInfo?.jobTags">
                            <span *ngFor="let tag of jobInfo?.jobTags; let i = index">
                              {{ tag.description }}
                              <span *ngIf="i < jobInfo?.jobTags?.length - 1">, </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-6 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Region</div>
                          <div class="ui-grid-col-7">{{ jobInfo?.region?.name || '' }}</div>
                        </div>
                        <div class="ui-grid-col-6 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Purchase Channel</div>
                          <div class="ui-grid-col-7">
                            {{ jobInfo?.purchaseChannel?.displayName || '' }}
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <div class="ui-grid-col-6 ui-sm-12">
                          <div class="ui-grid-col-5 bold">Depot</div>
                          <div class="ui-grid-col-7">{{ jobInfo?.depot?.name || '' }}</div>
                        </div>
                      </div>
                      <div class="ui-g-12" *ngIf="organisationTypeId == 1">
                        <button
                          pButton
                          label="Unassign Supplier"
                          (click)="removeFromSupplier()"
                          [disabled]="isJobCompleted(jobInfo)"
                          ngClass="mt-1"
                        ></button>
                        <button
                          pButton
                          label="Impersonate Supplier"
                          (click)="impersonateSupplier()"
                          ngClass="mt-1"
                          [disabled]="isImpersonating"
                        ></button>

                        <ng-container
                          *ngTemplateOutlet="previousSuppliers; context: { jobInfo: jobInfo }"
                        ></ng-container>
                      </div>
                    </div>
                  </p-panel>
                </div>

                <div *ngIf="jobInfo?.supplier != null" class="job-data-left">
                  <carry-over-auth
                    [jobInfo]="jobInfo"
                    [organisationTypeId]="organisationTypeId"
                    [organisationId]="organisationId"
                  ></carry-over-auth>
                </div>

                <div *ngIf="canDeploy()" class="mt-2">
                  <p-panel header="Supplier Information">
                    <div class="ui-g">
                      <div class="ui-g-12">
                        <button
                          class=""
                          type="button"
                          (click)="deployJob()"
                          label="Deploy"
                          pButton
                        ></button>
                        <button
                          class="pull-right mt-1"
                          type="button"
                          (click)="deployJobToSupplier()"
                          label="Deploy Supplier"
                          pButton
                        ></button>

                        <ng-container
                          *ngTemplateOutlet="previousSuppliers; context: { jobInfo: jobInfo }"
                        ></ng-container>
                      </div>
                    </div>
                  </p-panel>
                </div>
              </div>
              <div class="job-data-flex-right">
                <job-screen-history-timeline
                  [jobId]="jobId"
                  [organisationTypeId]="organisationTypeId"
                ></job-screen-history-timeline>
              </div>
            </div>

            <div class="mt-2">
              <div class="">
                <p-panel *ngIf="organisationTypeId == 1" header="Incidents">
                  <job-screen-incidents
                    [jobId]="jobId"
                    [jobInfo]="jobInfo"
                    [selectedTask]="selectedTask"
                    (onShowHistory)="showHistory()"
                  ></job-screen-incidents>
                </p-panel>
              </div>
            </div>

            <div class="mt-2">
              <div class="">
                <p-panel *ngIf="organisationTypeId == 1" header="Delay/Failures">
                  <job-screen-delay-failures [jobId]="jobId"></job-screen-delay-failures>
                </p-panel>
              </div>
            </div>

            <!-- Supplier feedback component for VME only - is not visible when no order is selected -->
            <div class="mt-2">
              <job-screen-supplier-feedback
                *ngIf="organisationTypeId == 1 && selectedOrder"
                [jobId]="jobId"
                [jobInfo]="jobInfo"
                [orderId]="selectedOrder.id"
                [taskId]="selectedTask ? selectedTask.id : null"
              >
              </job-screen-supplier-feedback>
            </div>
          </div>

          <div *ngIf="jobInfo && organisationTypeId == 2">
            <job-screen-history-timeline
              [jobId]="jobId"
              [organisationTypeId]="organisationTypeId"
            ></job-screen-history-timeline>
          </div>

          <div class="mt-2" id="additional-cost">
            <div class="">
              <p-panel header="Additional Costs">
                <div class="ui-g" style="height: 100%; padding-left: 0">
                  <div class="ui-g-12 datatable-panel" style="height: 100%; margin-bottom: 0px">
                    <p-table
                      #dt
                      [value]="additionalChargePage.items"
                      [responsive]="true"
                      [rowHover]="true"
                      [totalRecords]="additionalChargePage.total"
                      selectionMode="single"
                    >
                      <ng-template pTemplate="header">
                        <tr>
                          <th>Reg Number</th>
                          <th>Amount</th>
                          <th style="width: 20%">Description</th>
                          <th>Charge Type</th>
                          <th>Photo</th>
                          <th>Approval Status</th>
                          <th>Logged</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-itemUntyped>
                        <ng-container *ngIf="asCustomerCharge(itemUntyped) as item">
                          <tr>
                            <td>{{ item.vehicleReg }}</td>
                            <td>
                              {{ item.chargeAmount | currency : 'GBP' : 'symbol' : '1.2-2' }}
                            </td>
                            <td>
                              <div class="mb-2">{{ item.description }}</div>
                              <div *ngIf="item.proRatedChargingTimeDuration != null">
                                <!--Using ProRated because charging and waiting time duration is non-nullable and therefore returns null -->
                                <div *ngIf="item.started != null">
                                  <b>Started:</b>
                                  {{ item.started | datex : "ddd DD MMM 'YY HH:mm:ss" }}
                                </div>
                                <div *ngIf="item.ended != null">
                                  <b>Ended:</b>
                                  {{ item.ended | datex : "ddd DD MMM 'YY HH:mm:ss" }}
                                </div>
                                <div *ngIf="item.chargingTimeDuration != null">
                                  <b>Total duration:</b>{{ item.chargingTimeDuration }}
                                </div>
                                <div *ngIf="item.proRatedChargingTimeDuration != null">
                                  <b>ProRated duration</b>
                                  {{ item.proRatedChargingTimeDuration }}
                                </div>
                              </div>

                              <div *ngIf="item.proRatedWaitingTimeDuration != null">
                                <div *ngIf="item.started != null">
                                  <b>Started:</b>
                                  {{ item.started | datex : "ddd DD MMM 'YY HH:mm:ss" }}
                                </div>
                                <div *ngIf="item.ended != null">
                                  <b>Ended:</b>
                                  {{ item.ended | datex : "ddd DD MMM 'YY HH:mm:ss" }}
                                </div>
                                <div *ngIf="item.waitingTimeDuration != null">
                                  <b>Total duration:</b> {{ item.waitingTimeDuration }}
                                </div>
                                <div *ngIf="item.proRatedWaitingTimeDuration != null">
                                  <b>ProRated duration</b>
                                  {{ item.proRatedWaitingTimeDuration }}
                                </div>
                              </div>
                            </td>
                            <td>{{ item.additionalChargeTypeName }}</td>
                            <td class="text-center">
                              <a
                                *ngIf="item.imagePublicUrl"
                                style="cursor: pointer"
                                (click)="openExpensePhoto(item.imagePublicUrl)"
                              >
                                <i class="material-icons">photo_camera</i>
                              </a>
                            </td>
                            <td class="text-center">
                              {{ item.additionalChargeStatusName }}
                            </td>
                            <td>{{ item.createdOn | datex : "ddd DD MMM 'YY" }}</td>
                          </tr>
                        </ng-container>
                      </ng-template>
                    </p-table>
                    <ng-template #loading>Loading...</ng-template>
                  </div>
                </div>
              </p-panel>
            </div>
          </div>

          <!--<div class="ui-g" *ngIf="jobInfo?.customerRating || jobInfo?.supplierRating">
            <div
              class="ui-g-6 ui-sm-12"
              *ngIf="jobInfo?.customerRating && (organisationTypeId == 1 || organisationTypeId == 3)"
            >
              <p-panel header="Average Customer Ratings">
                <p-rating
                  [(ngModel)]="jobInfo.customerRating"
                  readonly="true"
                  stars="5"
                  [cancel]="false"
                  [style.text-align]="center"
                ></p-rating>
              </p-panel>
            </div>
            <div class="ui-g-6 ui-sm-12" *ngIf="jobInfo?.supplierRating && organisationTypeId == 1">
              <p-panel header="Average Supplier Ratings">
                <p-rating
                  [(ngModel)]="jobInfo.supplierRating"
                  readonly="true"
                  stars="5"
                  [cancel]="false"
                  [style.text-align]="center"
                ></p-rating>
              </p-panel>
            </div>
          </div>-->
        </div>

        <div class="mt-2">
          <div class="card ui-panel p-3">
            <div class="order-list-header-bar">
              <h2 class="sub-header-bar">Job Orders</h2>
              <button
                *ngIf="organisationTypeId == 1 && jobInfo?.statusId == jobStatus_Created"
                type="button"
                pButton
                label="Order Sequencing"
                class="ui-button"
                (click)="editTaskSequence()"
              ></button>
            </div>
            <p-table
              [value]="jobInfo?.orders"
              selectionMode="single"
              [(selection)]="selectedOrder"
              [responsive]="true"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th class="break-word" *ngIf="orderSequencingEnabled">Sequence</th>
                  <th class="break-word">Order Number</th>
                  <th class="break-word" *ngIf="organisationTypeId != 3">Customer Name</th>
                  <th class="break-word" *ngIf="organisationTypeId != 3 && !hasCustomerBookingRole">
                    Customer Price
                  </th>
                  <th
                    class="break-word"
                    *ngIf="organisationTypeId == 1 && jobInfo?.statusId == jobStatus_Closed"
                  >
                    Customer Quote
                  </th>
                  <th
                    class="break-word"
                    *ngIf="organisationTypeId != 3 && jobHasOrdersWithInspectAndCollect()"
                  >
                    Inspection Charge
                  </th>
                  <th class="break-word" *ngIf="organisationTypeId == 1">Postcode Premium</th>
                  <th class="break-word" *ngIf="organisationTypeId != 3">Cost Centre</th>
                  <th class="break-word" *ngIf="organisationTypeId != 3">Customer Tags</th>
                  <th class="break-word po-number-cell">Purchase Number</th>
                  <th class="break-word">Status</th>
                  <th class="break-word" *ngIf="organisationTypeId != 3">
                    <span>Department</span>
                  </th>
                  <th class="break-word" *ngIf="organisationTypeId != 3">Team</th>
                  <th class="break-word">Customer Movement Type</th>
                  <th class="break-word" *ngIf="organisationTypeId == 1">Cancel Status</th>
                  <th class="break-word" *ngIf="organisationTypeId == 1">
                    Sub Cancellation Status
                  </th>
                  <th class="break-word" *ngIf="organisationTypeId == 1">Cancel Description</th>
                  <th class="break-word" *ngIf="organisationTypeId == 1">Channel</th>
                  <th class="break-word" *ngIf="organisationTypeId == 1">Booked By</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-order>
                <tr [pSelectableRow]="order">
                  <td class="break-word align-center" *ngIf="orderSequencingEnabled">
                    {{ order.localOrderSequence }}
                  </td>
                  <td class="break-word">{{ order.customer ? order.orderNumber : '' }}</td>
                  <td class="break-word" *ngIf="organisationTypeId != 3">
                    {{ order.customer ? order.customer.name : '' }}
                  </td>
                  <td class="break-word" *ngIf="organisationTypeId != 3 && !hasCustomerBookingRole">
                    <span *ngIf="hasCustomerPriceRole; else noCustomerPriceRole">
                      {{ order.maxPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                    </span>
                    <ng-template #noCustomerPriceRole>
                      <span *ngIf="order.includedMilesFixed; else normalPrice">
                        {{ order.customerPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                      </span>
                      <ng-template #normalPrice>
                        <span *ngIf="order.isOverridePrice">
                          {{ order.customerPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                        </span>
                        <span *ngIf="!order.isOverridePrice && isOrderCompletedOrCancelled(order)">
                          {{ order.transactionsPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                        </span>
                        <span *ngIf="!order.isOverridePrice && !isOrderCompletedOrCancelled(order)">
                          {{ order.minPrice | currency : 'GBP' : 'symbol' : '1.2-2' }} -
                          {{ order.maxPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                        </span>
                      </ng-template>
                    </ng-template>
                  </td>
                  <td
                    class="break-word"
                    *ngIf="
                      !order.isOverridePrice &&
                      organisationTypeId == 1 &&
                      jobInfo?.statusId == jobStatus_Closed
                    "
                  >
                    <span *ngIf="order.minPrice && order.maxPrice"
                      >{{ order.minPrice | currency : 'GBP' : 'symbol' : '1.2-2' }} -
                      {{ order.maxPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</span
                    >
                    <span *ngIf="order.isOverridePrice">
                      {{ order.customerPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                    </span>
                  </td>
                  <td
                    class="break-word"
                    *ngIf="organisationTypeId != 3 && jobHasOrdersWithInspectAndCollect()"
                  >
                    <span>{{
                      order.inspectionCharge | currency : 'GBP' : 'symbol' : '1.2-2'
                    }}</span>
                  </td>
                  <td class="break-word" *ngIf="organisationTypeId == 1">
                    <span>{{
                      order.customerPostcodePremium | currency : 'GBP' : 'symbol' : '1.2-2'
                    }}</span>
                  </td>
                  <td class="break-word" *ngIf="organisationTypeId != 3">
                    {{ order.accountCodeList ? order.accountCodeList.code : '' }}
                  </td>
                  <td class="break-word" *ngIf="organisationTypeId != 3">
                    {{ getCustomerTags(order.orderTags) }}
                  </td>
                  <td class="break-word po-number-cell">
                    <span class="po-number-value">{{ order.purchaseOrderNo }}</span>
                  </td>
                  <td class="break-word">{{ getOrderStatus(order.statusId) }}</td>
                  <td class="break-word" *ngIf="organisationTypeId != 3">
                    {{ order.customerDepartment ? order.customerDepartment.name : '' }}
                  </td>
                  <td class="break-word" *ngIf="organisationTypeId != 3">
                    {{ order.customerTeam ? order.customerTeam.name : '' }}
                  </td>
                  <td class="break-word">{{ order.taskTypeName }}</td>
                  <td class="break-word" *ngIf="organisationTypeId == 1">
                    <div title="{{ order.cancellationStatusName }}">
                      {{ order.cancellationStatusName }}
                    </div>
                  </td>
                  <td class="break-word" *ngIf="organisationTypeId == 1">
                    <div title="{{ order.subCancellationStatusName }}">
                      {{ order.subCancellationStatusName }}
                    </div>
                  </td>
                  <td class="break-word" *ngIf="organisationTypeId == 1">
                    <div title="{{ order.cancellationDescription }}">
                      {{ order.cancellationDescription }}
                    </div>
                  </td>
                  <td class="break-word" *ngIf="organisationTypeId == 1">
                    <div title="{{ order.requestChannel?.displayName }}">
                      {{ order.requestChannel?.displayName }}
                    </div>
                  </td>
                  <td class="break-word" *ngIf="organisationTypeId == 1">
                    <div (click)="showBookingInfoDialog(order, $event)">
                      {{ order.user?.firstName }}
                      {{ order.user?.lastName }}
                      <i class="fa fa-info-circle"></i>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <div class="mt-4" style="width: 100%; height: 40px">
              <button
                type="button"
                *ngIf="organisationTypeId == 1"
                (click)="impersonateCustomer()"
                pButton
                icon="fa fa-user"
                label="Impersonate Customer"
                class="ui-button btn-to-right"
                [disabled]="!selectedOrder || isImpersonating"
              ></button>

              <button
                *ngIf="organisationTypeId == 2 || organisationTypeId == 4"
                type="button"
                (click)="copyOrder(selectedOrder)"
                pButton
                icon="fa ui-icon-content-copy"
                label="Copy Order"
                class="ui-button btn-to-right"
                [disabled]="!selectedOrder"
              ></button>

              <button
                type="button"
                *ngIf="
                  organisationTypeId == 1 || organisationTypeId == 2 || organisationTypeId == 4
                "
                (click)="showEditOrderDialog(selectedOrder)"
                pButton
                icon="fa ui-icon-edit"
                label="Edit"
                class="ui-button btn-to-right"
                [disabled]="!selectedOrder"
              ></button>

              <button
                pButton
                *ngIf="isCancelOrderEnableForVME()"
                [label]="
                  cancelAction == cancelOrderAction_CustomerHoursAtWhichCap1Charged
                    ? 'Abort Order'
                    : 'Cancel Order'
                "
                class="btn-to-right"
                (click)="cancelOrder()"
              ></button>

              <!-- <button *ngIf="selectedOrder && (selectedOrder.statusId == jobStatus_Closed || selectedOrder.statusId == jobStatus_Cancelled)  && organisationTypeId !=3"
                          class="btn-to-right" type="button" (click)="showPriceDetailsOrder()"
                          label="Price Details" pButton
                          [disabled]="!selectedOrder"></button> -->
            </div>
          </div>
        </div>
        <div
          class="ui-g card card-w-title"
          id="details-section"
          style="scroll-margin: 72px"
          *ngIf="selectedOrder != null"
        >
          <div class="ui-g-12">
            <job-details
              [orgTypeId]="organisationTypeId"
              [job]="selectedOrder"
              [jobInfo]="jobInfo"
              (selectedTaskChange)="selectTask($event)"
              [hideTaskSchedule]="organisationTypeId == 2 || organisationId == 3"
            ></job-details>
          </div>

          <div class="ui-g-12">
            <edit-task
              *ngIf="
                selectedTask && organisationTypeId == 1 && jobInfo?.statusId != jobStatus_Closed
              "
              [selectedTask]="selectedTask"
              (taskUpdated)="taskUpdated($event)"
            ></edit-task>

            <button
              *ngIf="
                selectedTask &&
                !selectedTask.isCancelled &&
                !selectedTask.isComplete &&
                (organisationTypeId == 1 ||
                  (organisationTypeId == 3 && jobInfo.supplierId == organisationId))
              "
              pButton
              (click)="onEditSupplierScheduleClick()"
              label="Edit Task Schedule"
              class="ui-button btn-to-right"
              [title]="
                organisationTypeId == 3 && !selectedTask.canBeRescheduled
                  ? 'Task too close to collection date'
                  : ''
              "
              [disabled]="organisationTypeId == 3 && !selectedTask.canBeRescheduled"
            ></button>

            <button
              *ngIf="selectedTask && organisationTypeId == 1"
              pButton
              (click)="editLocations(selectedTask.id)"
              label="Edit Locations"
              class="ui-button btn-to-right"
              [disabled]="isJobCompleted(jobInfo) || !selectedTask"
            ></button>

            <!--            <button
              pButton
              *ngIf="organisationTypeId == 3"
              (click)="searchForTheJob()"
              label="Find Similar Jobs"
              class="ui-button btn-to-right"
              [disabled]="isJobCompleted(jobInfo)"
            ></button>-->

            <reschedule-task
              *ngIf="organisationTypeId == 1 && !isJobCompleted(jobInfo)"
              (click)="customerReschedule()"
              [selectedOrder]="selectedOrder"
              [jobInfo]="jobInfo"
              [selectedTask]="selectedTask"
            ></reschedule-task>
          </div>
        </div>

        <div class="card" *ngIf="selectedTask != null">
          <h2 class="sub-header-bar">Task Information</h2>
          <div class="flex flex-wrap">
            <div style="flex-grow: 1; flex-basis: 150px">
              <p-panel
                header="Service Types"
                *ngIf="organisationTypeId == 1"
                [style]="{ 'margin-bottom': '1em' }"
              >
                <div class="ui-g">
                  <div class="ui-g-12">Customer Service Type: {{ selectedTask.taskTypeName }}</div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12">
                    Engineius Service Type: {{ selectedTask.actualTaskTypeName }}
                  </div>
                  <div class="ui-g-12">
                    <button
                      *ngIf="allowServiceTypeEdit()"
                      pButton
                      (click)="editActualTaskType(selectedTask)"
                      label="Change"
                      class="ui-button"
                    ></button>
                  </div>
                </div>
              </p-panel>
              <p-panel header="MoDel PIN" class="driver-notes" [style]="{ 'margin-bottom': '1em' }">
                <div class="ui-g">
                  <div class="note-flex">
                    <div class="note-header flex-grow-1">
                      <div class="ui-g-12">
                        <span class="model-pin-bold mr-1">PIN Number:</span
                        ><span class="model-pin-bold ml-1">{{ selectedTask?.moDelPin }}</span>
                      </div>
                    </div>
                    <div class="flex-shrink-1 ml-auto">
                      <div
                        *ngIf="organisationTypeId == 1 || organisationTypeId == 2"
                        style="padding: 1em 0.5em 0 0.5em"
                      >
                        <button
                          pButton
                          icon="fa ui-icon-edit"
                          (click)="showMoDelPinDialog()"
                        ></button>
                      </div>
                    </div>
                  </div>
                </div>
              </p-panel>
              <p-panel
                header="Release Code"
                class="driver-notes"
                [style]="{ 'margin-bottom': '1em' }"
              >
                <div class="ui-g">
                  <div class="note-flex">
                    <div class="note-header flex-grow-1">
                      <div class="ui-g-12">
                        <span class="model-pin-bold mr-1">Release Code:</span
                        ><span class="model-pin-bold ml-1">{{ selectedTask?.releaseCode }}</span>
                      </div>
                    </div>
                    <div class="flex-shrink-1 ml-auto">
                      <div
                        *ngIf="organisationTypeId == 1 || organisationTypeId == 2"
                        style="padding: 1em 0.5em 0 0.5em"
                      >
                        <button
                          pButton
                          icon="fa ui-icon-edit"
                          (click)="showReleaseCodeDialog()"
                        ></button>
                      </div>
                    </div>
                  </div>
                </div>
              </p-panel>

              <!-- No Trade Plates
              <p-panel
                header="Trade Plate Number"
                *ngIf="
                  organisationTypeId == 1 || organisationTypeId == 3 || organisationTypeId == 4
                "
                [style]="{ 'margin-bottom': '1em' }"
              >
                <div class="ui-g">
                  <div class="ui-g-12">{{ jobInfo?.tradePlateNumber }}</div>
                  <div *ngIf="organisationTypeId == 1" class="ui-g-12">
                    <button
                      pButton
                      (click)="editTradePlate()"
                      label="Change"
                      class="ui-button"
                    ></button>
                  </div>
                </div>
              </p-panel>
              --->

              <p-panel
                header="Recognition Status"
                *ngIf="organisationTypeId == 1"
                [style]="{ 'margin-bottom': '1em' }"
              >
                <div class="ui-g">
                  <div class="ui-g-12">Status: {{ selectedTask.regStatusName }}</div>
                  <div class="ui-g-6">
                    <button
                      pButton
                      (click)="editRegStatus(selectedTask)"
                      label="Change"
                      class="ui-button"
                    ></button>
                  </div>
                  <div class="ui-g-6" style="text-align: right">
                    <button
                      pButton
                      (click)="setRegStatusToManualUpdate(selectedTask)"
                      label="Set to 'Manually Updated'"
                      class="ui-button"
                      pTooltip="Change Verification Status to 'Manually Updated'"
                    ></button>
                  </div>
                </div>
              </p-panel>

              <p-panel header="Driver Details">
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-12">
                      <h4>Driver</h4>
                    </div>
                    <div
                      class="ui-g-12"
                      style="border-bottom: 1px dotted lightgray; word-wrap: break-word"
                      title="{{ driverTitle }}"
                    >
                      {{ driverName }}
                    </div>
                    <div
                      class="ui-g-12"
                      style="border-bottom: 1px dotted lightgray; word-wrap: break-word"
                    >
                      Licence number:
                      {{ selectedTask.driver ? selectedTask.driver.drivingLicenceNumber : '' }}
                    </div>
                    <div
                      class="ui-g-12"
                      style="border-bottom: 1px dotted lightgray; word-wrap: break-word"
                    >
                      Mobile number:

                      <a
                        *ngIf="selectedTask.driver"
                        href="tel:{{ selectedTask.driver.mobileNumber }}"
                      >
                        {{ selectedTask.driver.mobileNumber }}
                      </a>
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <div class="ui-g-12">
                      <h4>Truck</h4>
                    </div>
                    <div
                      class="ui-g-12"
                      style="border-bottom: 1px dotted lightgray; word-wrap: break-word"
                    >
                      {{
                        selectedTask.truck
                          ? selectedTask.truck.make +
                            ' ' +
                            selectedTask.truck.model +
                            '(' +
                            selectedTask.truck.registration +
                            ')'
                          : ''
                      }}
                    </div>
                  </div>
                  <div
                    class="ui-g-12"
                    *ngIf="
                      (organisationTypeId == 1 || organisationTypeId == 3) && jobInfo?.supplier
                    "
                  >
                    <button
                      pButton
                      label="Change"
                      (click)="showChangeDriverTruck()"
                      [disabled]="isJobCompleted(jobInfo)"
                    ></button>
                  </div>
                </div>
              </p-panel>
              <p-panel
                *ngIf="toDisplayDriverNotes()"
                header="Driver Notes"
                class="driver-notes"
                [style]="{ 'margin-top': '1em' }"
              >
                <div class="ui-g">
                  <div class="note-flex">
                    <div class="note-header flex-grow-1">
                      <div class="pick-up-color" style="position: relative; margin-bottom: 0">
                        <i class="vme-material-icons route-icon">&#xe805;</i>
                        <div style="margin-left: 2em; font-weight: bold; font-size: 16px">
                          Pick-up
                        </div>
                      </div>
                    </div>
                    <div
                      class="flex-shrink-1 ml-auto"
                      *ngIf="!isJobCompleted(jobInfo) && organisationTypeId != 3"
                    >
                      <div style="padding: 1em 0.5em 0 0.5em">
                        <button
                          pButton
                          icon="fa ui-icon-edit"
                          (click)="setChangePickupDialog(true)"
                        ></button>
                      </div>
                    </div>
                  </div>

                  <div
                    class="note ui-g"
                    *ngIf="selectedTask.pickupForename || selectedTask.pickupSurname"
                  >
                    <div class="note-inner">
                      Contact: {{ selectedTask.pickupForename }} {{ selectedTask.pickupSurname }}
                    </div>
                  </div>

                  <div
                    class="note ui-g"
                    *ngIf="selectedTask.pickupEmail && organisationTypeId != 3"
                  >
                    <div class="note-inner">
                      Email:
                      <a href="mailto:{{ selectedTask.pickupEmail }}">{{
                        selectedTask.pickupEmail
                      }}</a>
                    </div>
                  </div>

                  <div
                    class="note ui-g"
                    *ngIf="selectedTask.pickupSecondaryEmail && organisationTypeId != 3"
                  >
                    <div class="note-inner">
                      Secondary Email:
                      <a href="mailto:{{ selectedTask.pickupSecondaryEmail }}">{{
                        selectedTask.pickupSecondaryEmail
                      }}</a>
                    </div>
                  </div>

                  <div
                    class="note ui-g"
                    *ngIf="selectedTask.pickupPhone1 || selectedTask.pickupPhone2"
                  >
                    <div class="note-inner">
                      Phone:
                      <a href="tel:{{ selectedTask.pickupPhone1 }}">{{
                        selectedTask.pickupPhone1
                      }}</a>
                      <span *ngIf="selectedTask.pickupPhone1 && selectedTask.pickupPhone2">
                        or
                      </span>
                      <a href="tel:{{ selectedTask.pickupPhone2 }}">{{
                        selectedTask.pickupPhone2
                      }}</a>
                    </div>
                  </div>
                  <div
                    class="note ui-g note-inner"
                    *ngFor="let note of getNotes(selectedTask.notes, true); let i = index"
                    style="width: 100%; overflow-wrap: anywhere"
                    [class.note-even]="i % 2 == 0"
                    [class.note-odd]="i % 2 == 1"
                  >
                    <div class="ui-g-12 description">
                      {{ note.description }}
                    </div>
                  </div>

                  <div style="display: flex; width: 100%; flex-direction: row; flex-wrap: nowrap">
                    <div class="ui-g-12 note-header flex-grow-1">
                      <div class="drop-off-color" style="position: relative; margin-bottom: 0">
                        <i class="vme-material-icons route-icon">&#xe804;</i>
                        <div style="margin-left: 2em; font-weight: bold; font-size: 16px">
                          Drop-off
                        </div>
                      </div>
                    </div>
                    <div
                      class="flex-shrink-1 ml-auto"
                      *ngIf="!isJobCompleted(jobInfo) && organisationTypeId != 3"
                    >
                      <div style="padding: 1em 0.5em 0 0.5em">
                        <button
                          pButton
                          icon="fa ui-icon-edit"
                          (click)="setChangeDropoffDialog(true)"
                        ></button>
                      </div>
                    </div>
                  </div>

                  <div
                    class="note ui-g"
                    *ngIf="selectedTask.dropoffForename || selectedTask.dropoffSurname"
                  >
                    <div class="note-inner">
                      Contact: {{ selectedTask.dropoffForename }} {{ selectedTask.dropoffSurname }}
                    </div>
                  </div>

                  <div
                    class="note ui-g"
                    *ngIf="selectedTask.dropoffEmail && organisationTypeId != 3"
                  >
                    <div class="note-inner">
                      Email:
                      <a href="mailto:{{ selectedTask.dropoffEmail }}">{{
                        selectedTask.dropoffEmail
                      }}</a>
                    </div>
                  </div>

                  <div
                    class="note ui-g"
                    *ngIf="selectedTask.dropoffSecondaryEmail && organisationTypeId != 3"
                  >
                    <div class="note-inner">
                      Secondary Email:
                      <a href="mailto:{{ selectedTask.dropoffSecondaryEmail }}">{{
                        selectedTask.dropoffSecondaryEmail
                      }}</a>
                    </div>
                  </div>

                  <div
                    class="note ui-g"
                    *ngIf="selectedTask.dropoffPhone1 || selectedTask.dropoffPhone2"
                  >
                    <div class="note-inner">
                      Phone:
                      <a href="tel:{{ selectedTask.dropoffPhone1 }}">{{
                        selectedTask.dropoffPhone1
                      }}</a>
                      <span *ngIf="selectedTask.dropoffPhone1 && selectedTask.dropoffPhone2">
                        or
                      </span>
                      <a href="tel:{{ selectedTask.dropoffPhone2 }}">{{
                        selectedTask.dropoffPhone2
                      }}</a>
                    </div>
                  </div>
                  <div
                    class="note ui-g"
                    *ngFor="let note of getNotes(selectedTask.notes, false); let i = index"
                    style="width: 100%; overflow-wrap: anywhere; padding: 0.5em 1em"
                    [class.note-even]="i % 2 == 0"
                    [class.note-odd]="i % 2 == 1"
                  >
                    <div class="ui-g-12 description">
                      {{ note.description }}
                    </div>
                  </div>
                  <div class="ui-g-12" *ngIf="allowAddDriverNotes">
                    <button
                      pButton
                      label="Add"
                      (click)="showAddDriverNotes()"
                      [disabled]="isJobCompleted(jobInfo)"
                    ></button>
                  </div>
                </div>
              </p-panel>

              <site-opening-hours-panel
                *ngIf="selectedTask"
                [taskId]="selectedTask.id"
                [pickupLocation]="selectedTask.pickupLocation"
                [dropOffLocation]="selectedTask.dropoffLocation"
                [taskSiteOpeningHours]="taskSiteOpeningHours"
                [editAllowed]="!isJobCompleted(jobInfo) && organisationTypeId != 3"
                (updated)="onTaskSiteOpeningHoursUpdated($event)"
              ></site-opening-hours-panel>

              <p-panel
                *ngIf="organisationTypeId == 1 || organisationTypeId == 2"
                header="Pick-up Rating"
                [style]="{ 'margin-top': '1em' }"
              >
                <task-step-rating [task]="selectedTask" mode="pickup"></task-step-rating>
              </p-panel>

              <p-panel
                *ngIf="organisationTypeId == 1 || organisationTypeId == 2"
                header="Pick-up Person"
                [style]="{ 'margin-top': '1em' }"
              >
                <div class="ui-g">
                  <div class="ui-g-12">Name:</div>
                  <div class="ui-g-12">{{ getPrintName(true) }}</div>
                </div>
              </p-panel>

              <p-panel
                *ngIf="organisationTypeId == 1 || organisationTypeId == 2"
                header="Drop-off Rating"
                [style]="{ 'margin-top': '1em' }"
              >
                <task-step-rating [task]="selectedTask" mode="dropoff"></task-step-rating>
              </p-panel>

              <p-panel
                *ngIf="organisationTypeId == 1 || organisationTypeId == 2"
                header="Drop-off Person"
                [style]="{ 'margin-top': '1em' }"
              >
                <div class="ui-g">
                  <div class="ui-g-12">Name:</div>
                  <div class="ui-g-12">{{ getPrintName(false) }}</div>
                </div>
              </p-panel>

              <p-panel header="Pick-Up Fuel Level" [style]="{ 'margin-top': '1em' }">
                <div class="">
                  <div *ngIf="organisationTypeId == 1" class="flex flex-wrap grid-gap-5">
                    <div class="flex-grow-1" style="margin-top: 0.5em">
                      <p-dropdown
                        [options]="fuelLevelsSelectItems"
                        placeholder=""
                        [disabled]="organisationTypeId != 1"
                        autoWidth="false"
                        [style]="{ width: '100%', 'min-width': '0px' }"
                        [(ngModel)]="selectedTask.pickupFuel"
                      ></p-dropdown>
                    </div>
                    <div class="flex-shrink-1" *ngIf="organisationTypeId == 1">
                      <button
                        pButton
                        label="Save"
                        style="margin-left: 0px"
                        (click)="saveFuelReading(true)"
                        [disabled]="!selectedTask.pickupFuel"
                      ></button>
                    </div>
                  </div>

                  <div *ngIf="organisationTypeId != 1" class="flex-grow-1">
                    {{
                      isElectric()
                        ? selectedTask.pickupFuel + '%'
                        : getFuelLevel(selectedTask.pickupFuel)
                    }}
                  </div>
                </div>
              </p-panel>

              <p-panel header="Drop-off Fuel Level" [style]="{ 'margin-top': '1em' }">
                <div class="">
                  <div *ngIf="organisationTypeId == 1" class="flex flex-wrap grid-gap-5">
                    <div class="flex-grow-1" style="margin-top: 0.5em">
                      <p-dropdown
                        [options]="fuelLevelsSelectItems"
                        placeholder=""
                        [disabled]="organisationTypeId != 1"
                        autoWidth="false"
                        [style]="{ width: '100%', 'min-width': '0px' }"
                        [(ngModel)]="selectedTask.dropoffFuel"
                      ></p-dropdown>
                    </div>
                    <div class="flex-shrink-1" *ngIf="organisationTypeId == 1">
                      <button
                        pButton
                        label="Save"
                        style="margin-left: 0px"
                        (click)="saveFuelReading(false)"
                        [disabled]="!selectedTask.dropoffFuel"
                      ></button>
                    </div>
                  </div>

                  <div *ngIf="organisationTypeId != 1" class="flex-grow-1">
                    {{
                      isElectric()
                        ? selectedTask.dropoffFuel + '%'
                        : getFuelLevel(selectedTask.dropoffFuel)
                    }}
                  </div>
                </div>
              </p-panel>

              <p-panel header="Pick-Up Odometer Reading" [style]="{ 'margin-top': '1em' }">
                <div class="flex flex-wrap grid-gap-5" style="padding: 0.5em">
                  <div class="flex-grow-1" style="line-height: 30px">
                    {{ selectedTask.pickupOdometer | number : '2.' }}mi
                  </div>
                  <div class="flex-shrink-1" *ngIf="organisationTypeId == 1">
                    <button pButton label="Edit" (click)="showOdometerReadingDialog(true)"></button>
                  </div>
                </div>
              </p-panel>

              <p-panel header="Drop-Off Odometer Reading" [style]="{ 'margin-top': '1em' }">
                <div class="flex flex-wrap grid-gap-5" style="padding: 0.5em">
                  <div class="flex-grow-1" style="line-height: 30px">
                    {{ selectedTask.dropoffOdometer | number : '2.' }}mi
                  </div>
                  <div class="flex-shrink-1" *ngIf="organisationTypeId == 1">
                    <button
                      pButton
                      label="Edit"
                      (click)="showOdometerReadingDialog(false)"
                    ></button>
                  </div>
                  <div *ngIf="organisationTypeId == 1" class="col-6">
                    <div>Estimated: {{ selectedTask.estimatedMiles.toFixed(1) }}mi</div>
                    <div style="margin-top: 0.5em">Actual: {{ selectedTask.actualMiles }}mi</div>
                    <div style="margin-top: 0.5em">
                      <span *ngIf="selectedTask.actualMiles < selectedTask.estimatedMiles"
                        >Under</span
                      >
                      <span *ngIf="selectedTask.actualMiles > selectedTask.estimatedMiles"
                        >Over</span
                      >
                      : {{ selectedTask.milesDiff.toFixed(1) }}mi
                    </div>
                  </div>
                </div>
                <div *ngIf="organisationTypeId == 1" class="col-12 {{ displayRedAlert }}">
                  Percent % (Estimated VS Actual): {{ differencePercent.toFixed(1) }}%
                </div>
              </p-panel>

              <p-panel
                header="Inspection Handover Recordings"
                [style]="{ 'margin-top': '1em' }"
                *ngIf="
                  organisationTypeId == 2 &&
                  inspectionHandover &&
                  inspectionHandover.showInspectionHandover
                "
              >
                <div class="inspection-handover">
                  <div class="flex align-items-center justify-content-between">
                    <div class="grid-label-value">
                      <div>Recordings:</div>
                    </div>
                  </div>
                  <div
                    class="recording"
                    *ngFor="let media of inspectionHandover.media"
                    style="width: 100%; word-wrap: break-word"
                  >
                    <div class="description">
                      {{ media.description }}
                    </div>
                    <div class="play-icon" (click)="viewInspectionHandoverMedia(media)">
                      <i class="fa fa-play-circle" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </p-panel>
            </div>

            <div style="flex-grow: 3; flex-basis: 450px">
              <div class="ui-g-12">
                <p-panel id="driverChecklist">
                  <p-header>
                    Driver Checklist
                    <span *ngIf="selectedTask?.checklist?.categoryId > 0"
                      >:
                      <strong>{{
                        checklistService.ChecklistCategoryName[selectedTask.checklist.categoryId]
                      }}</strong></span
                    >
                  </p-header>

                  <!--
                  {{ ((selectedTask?.checklist?.categoryId > 0) ? ('<strong>: ' + checklistCategoryName[selectedTask.checklist.categoryId] + '</strong>') : '') }}
                  -->

                  <div class="ui-g">
                    <p-fieldset class="ui-g-6 ui-lg-6 ui-md-12 ui-sm-12">
                      <p-header class="pick-up-color" style="position: relative; margin-bottom: 0">
                        <i class="vme-material-icons route-icon">&#xe805;</i>
                        <div style="margin-left: 2em; font-weight: bold; font-size: 16px">
                          Pick-up
                        </div>
                      </p-header>
                      <ng-container
                        *ngTemplateOutlet="
                          checklist_steps_template;
                          context: { steps: driverChecklistPickUp }
                        "
                      ></ng-container>
                    </p-fieldset>
                    <p-fieldset class="ui-g-6 ui-lg-6 ui-md-12 ui-sm-12">
                      <p-header class="drop-off-color" style="position: relative; margin-bottom: 0">
                        <i class="vme-material-icons route-icon">&#xe804;</i>
                        <div style="margin-left: 2em; font-weight: bold; font-size: 16px">
                          Drop-off
                        </div>
                      </p-header>
                      <ng-container
                        *ngTemplateOutlet="
                          checklist_steps_template;
                          context: { steps: driverChecklistDropOff }
                        "
                      ></ng-container>
                    </p-fieldset>
                  </div>
                  <div *ngIf="allowDriverChecklistEdit">
                    <div class="grid checklist-actions">
                      <div class="p-2">
                        <button
                          *ngIf="!isInvoiced"
                          type="button"
                          (click)="checklistManualEdit()"
                          pButton
                          [label]="isDriverChecklistManualEdit ? 'End Edit' : 'Manual Edit'"
                          [disabled]="
                            (organisationTypeId != 1 && isJobCompleted(jobInfo)) ||
                            !supplierAssigned
                          "
                          class="ui-button"
                        ></button>

                        <span *ngIf="!supplierAssigned" class="text-caption"
                          >Supplier assignment required.</span
                        >

                        <button
                          pButton
                          *ngIf="
                            jobInfo.statusId == jobStatus_Paused ||
                            jobInfo.statusId == jobStatus_Started
                          "
                          icon="{{ isJobPaused ? 'fa fa-play' : 'fa fa-pause' }}"
                          (click)="onPauseResumeTask(isJobPaused)"
                          label="{{ isJobPaused ? 'Resume Task' : 'Pause Task' }}"
                          [disabled]="organisationTypeId != 1 && isJobCompleted(jobInfo)"
                          ngClass="{{
                            isJobPaused ? 'ui-button green-btn' : 'ui-button ui-button-secondary'
                          }}"
                        ></button>
                      </div>
                    </div>
                    <h4 *ngIf="isSupplierInvoiced && !isCustomerInvoiced">
                      <i><b>This Job has been invoiced to the Supplier</b></i>
                    </h4>
                    <h4 *ngIf="!isSupplierInvoiced && isCustomerInvoiced">
                      <i><b>This Job has been invoiced to the Customer</b></i>
                    </h4>
                    <h4 *ngIf="isSupplierInvoiced && isCustomerInvoiced">
                      <i><b>This Job has been invoiced to the Customer and Supplier</b></i>
                    </h4>
                  </div>
                </p-panel>
              </div>
              <div class="ui-g-12">
                <p-panel header="Photo Gallery" [style]="{ height: '100%' }">
                  <div class="gallery-wrapper">
                    <job-screen-gallery
                      [images]="pickupImages"
                      type="1"
                      [showAddButton]="canAddPhoto(1)"
                      [disableAddButton]="organisationTypeId != 1 && isJobCancelled(jobInfo)"
                      (onAddPhoto)="showAddPhotoToTaskStep($event)"
                      (onDeletePhoto)="deletePhotoToTaskStep($event, 1)"
                      (onEditPhoto)="showEditPhotoToTaskStep($event, 1)"
                      (onShowOdometerPhoto)="showOdometerPhoto($event)"
                      (onSetAreaCondition)="showSetAreaCondition($event)"
                    ></job-screen-gallery>
                  </div>

                  <div class="gallery-wrapper">
                    <job-screen-gallery
                      [images]="dropoffImages"
                      type="3"
                      [showAddButton]="canAddPhoto(3)"
                      [disableAddButton]="organisationTypeId != 1 && isJobCancelled(jobInfo)"
                      (onAddPhoto)="showAddPhotoToTaskStep($event)"
                      (onDeletePhoto)="deletePhotoToTaskStep($event, 3)"
                      (onEditPhoto)="showEditPhotoToTaskStep($event, 3)"
                      (onSetAreaCondition)="showSetAreaCondition($event)"
                    ></job-screen-gallery>
                  </div>
                </p-panel>
              </div>
              <div class="ui-g-12" *ngIf="organisationTypeId == 1">
                <p-panel header="Vehicle Information">
                  <div class="ui-g">
                    <div class="ui-g-12">
                      <div class="ui-grid-col-4 ui-md-6 ui-sm-12">
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Registration Number:</div>
                          <div class="ui-grid-col-7">
                            {{ selectedTask?.vehicle?.registrationNumber || '-' }}
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Make:</div>
                          <div class="ui-grid-col-7">{{ selectedTask?.vehicle?.make || '-' }}</div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Model:</div>
                          <div class="ui-grid-col-7">{{ selectedTask?.vehicle?.model || '-' }}</div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Fuel Type:</div>
                          <div class="ui-grid-col-7">
                            {{ selectedTask?.vehicle?.fuelType || '-' }}
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Transmission:</div>
                          <div class="ui-grid-col-7">
                            {{ selectedTask?.vehicle?.transmissionType || '-' }}
                          </div>
                        </div>
                      </div>

                      <div class="ui-grid-col-4 ui-md-6 ui-sm-12">
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Body:</div>
                          <div class="ui-grid-col-7">{{ selectedTask?.vehicle?.body || '-' }}</div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Color:</div>
                          <div class="ui-grid-col-7">{{ selectedTask?.vehicle?.color || '-' }}</div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Engine Size:</div>
                          <div class="ui-grid-col-7">
                            {{ selectedTask?.vehicle?.sizeEngine + 'cc' || '-' }}
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">VIN:</div>
                          <div class="ui-grid-col-7">{{ selectedTask?.vehicle?.vin || '-' }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="ui-g-12">
                      <div class="ui-grid-col-4 ui-md-6 ui-sm-12">
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Height:</div>
                          <div class="ui-grid-col-7">
                            {{ selectedTask?.vehicle?.height + 'mm' || '-' }}
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Kerb Weight:</div>
                          <div class="ui-grid-col-7">
                            {{ selectedTask?.vehicle?.kerbWeight + 'kg' || '-' }}
                          </div>
                        </div>
                      </div>

                      <div class="ui-grid-col-4 ui-md-6 ui-sm-12">
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Width:</div>
                          <div class="ui-grid-col-7">
                            {{ selectedTask?.vehicle?.width + 'mm' || '-' }}
                          </div>
                        </div>
                        <div class="ui-g-12">
                          <div class="ui-grid-col-5 bold">Wheelbase:</div>
                          <div class="ui-grid-col-7">
                            {{ selectedTask?.vehicle?.wheelbaseLength + 'mm' || '-' }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </p-panel>
              </div>
              <div class="ui-g-12" *ngIf="organisationTypeId == 1 || organisationTypeId == 3">
                <p-panel header="Driver Messages" [style]="{ height: '100%' }">
                  <div
                    class="driver-message-container"
                    style="height: 100%; position: relative; min-height: 50px"
                  >
                    <div>
                      <button
                        type="button"
                        (click)="ShowSendMessageToDriver()"
                        pButton
                        icon="fa ui-icon-message"
                        label="Send Message"
                        *ngIf="selectedTask.driver"
                        [disabled]="isJobCompleted(jobInfo)"
                        class="ui-button"
                      ></button>
                    </div>
                    <div *ngIf="selectedTask.driverMessages">
                      <div
                        class="messages ui-g"
                        *ngFor="let driverMessage of selectedTask.driverMessages; let i = index"
                        [class.message-even]="i % 2 == 0"
                        [class.message-odd]="i % 2 == 1"
                      >
                        <div class="ui-g-6 user-name">
                          {{ driverMessage.userName }}
                        </div>
                        <div class="ui-g-6 time-created">
                          Driver Checklist
                          {{ driverMessage.created | datelocal : "ddd DD MMM 'YY HH:mm" }}
                        </div>
                        <div class="ui-g-12 message-content">
                          {{ driverMessage.messageText }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="ui-g"
                      style="
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: gray;
                        opacity: 0.3;
                      "
                      *ngIf="isReloadDriverMessages"
                    >
                      <img
                        src="assets/images/loader.gif"
                        style="margin-left: 45%; margin-top: 10%"
                        width="50"
                        height="50"
                        alt="load"
                      />
                    </div>
                  </div>
                </p-panel>
              </div>
              <div class="ui-g-12">
                <p-panel header="Late Statuses" [style]="{ height: '100%' }">
                  <div class="ui-g">
                    <div class="ui-g-12">
                      <div class="ui-grid-col-4 ui-md-6 ui-sm-12">
                        <div class="ui-grid-col-5 bold">Pick-up Late Status:</div>
                        <div class="ui-grid-col-7">
                          {{ getLateStatusTitle(this.selectedTask.pickupLateStatusId) }}
                        </div>
                      </div>

                      <div class="ui-grid-col-8 ui-md-6 ui-sm-12">
                        <div class="ui-grid-col-4 bold">Pick-up Late Reason:</div>
                        <div class="ui-grid-col-8">
                          {{ this.selectedTask.pickupLateReason }}
                        </div>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-grid-col-4 ui-md-6 ui-sm-12">
                        <div class="ui-grid-col-5 bold">Drop-off Late Status:</div>
                        <div class="ui-grid-col-7">
                          {{ getLateStatusTitle(this.selectedTask.dropoffLateStatusId) }}
                        </div>
                      </div>

                      <div class="ui-grid-col-8 ui-md-6 ui-sm-12">
                        <div class="ui-grid-col-4 bold">Drop-off Late Reason:</div>
                        <div class="ui-grid-col-8">
                          {{ this.selectedTask.dropoffLateReason }}
                        </div>
                      </div>
                    </div>
                    <div class="ui-g-12" *ngIf="organisationTypeId == 1">
                      <button pButton label="Change" (click)="showLateStatusesDialog()"></button>
                    </div>
                  </div>
                </p-panel>
              </div>
            </div>
          </div>
          <div>
            <div class="mt-2">
              <div class="card card-w-title progress-bar-container">
                <progress-bar [currentStep]="taskTimelineCurrentStep" [steps]="taskTimelineSteps">
                  <ng-template #titleTemplate let-item="item">
                    <div style="padding-left: 5px; padding-right: 5px" class="progress-container">
                      <div style="width: 100%">
                        <div
                          class="progress-step-item-title task-information-title"
                          [class.customer-info]="item.isCustomer"
                          [class.system-info]="!item.isCustomer"
                        >
                          <span>{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template #lineTemplate let-item="item" let-i="i" let-length="length">
                    <div class="custom-left-progress" *ngIf="i > 0"></div>
                    <div class="custom-right-progress" *ngIf="i < length - 1"></div>
                    <span class="custom-progress-step-item-number"></span>
                  </ng-template>
                  <ng-template #dateTemplate let-item="item">
                    <span class="progress-step-item-date job-information-date" *ngIf="item.date">{{
                      item.date | datex : "ddd DD MMM 'YY HH:mm"
                    }}</span>
                  </ng-template>
                </progress-bar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <allocate-job-dialog
      *ngIf="allocateSupplier && jobAllocationInfo"
      [(visible)]="showAllocateJobDialog"
      [supplierId]="allocateSupplier.id"
      [job]="jobAllocationInfo"
      referrPage="jobScreen"
      (jobAllocated)="onAllocateJobSaved()"
      (close)="showAllocateJobDialog = false"
    >
    </allocate-job-dialog>

    <p-dialog
      header="Pick-up Contact Details"
      [(visible)]="pickupContactEdit"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '500px' }"
    >
      <form [formGroup]="pickupForm">
        <!-- todo: come back here, job for another day; selectedTask here causes a checked after change -->
        <div class="ui-g" style="position: relative" *ngIf="selectedTask">
          <div class="ui-g-6 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-pickupForename"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.pickupForename"
                formControlName="pickupForename"
                class="w-100"
              />
              <label for="edit-pickupForename">Forename</label>
            </div>
          </div>

          <div class="ui-g-6 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-pickupSurname"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.pickupSurname"
                formControlName="pickupSurname"
                class="w-100"
              />
              <label for="edit-pickupSurname">Surname</label>
            </div>
          </div>

          <div class="ui-g-12 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-pickupEmail"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.pickupEmail"
                formControlName="pickupEmail"
                class="w-100"
              />
              <label for="edit-pickupEmail">Email</label>
            </div>
            <div *ngIf="pickupForm?.controls?.pickupEmail?.errors?.email" class="text-danger">
              A valid email address is required
            </div>
          </div>

          <div class="ui-g-12 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-pickupSecondaryEmail"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.pickupSecondaryEmail"
                formControlName="pickupSecondaryEmail"
                class="w-100"
              />
              <label for="edit-pickupSecondaryEmail">Secondary Email</label>
            </div>
            <div
              *ngIf="pickupForm?.controls?.pickupSecondaryEmail?.errors?.email"
              class="text-danger"
            >
              A valid email address is required
            </div>
          </div>

          <div class="ui-g-6 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-pickupPhone1"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.pickupPhone1"
                formControlName="pickupPhone1"
                class="w-100"
              />
              <label for="edit-pickupPhone1">Mobile Number</label>
            </div>
            <div *ngIf="pickupPhone1Error != ''" class="text-danger">
              {{ pickupPhone1Error }}
            </div>
          </div>

          <div class="ui-g-6 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-pickupPhone2"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.pickupPhone2"
                formControlName="pickupPhone2"
                class="w-100"
              />
              <label for="edit-pickupPhone2">Phone Number (alternative)</label>
            </div>
            <div *ngIf="pickupPhone2Error != ''" class="text-danger">
              {{ pickupPhone2Error }}
            </div>
          </div>

          <!-- in case they decide we need 2 phone fields
  <div class="ui-g-12">
     <div class="ui-float-label u-g-12">
         <input id="edit-pickupPhone2" type="text" pInputText [(ngModel)]="selectedTask.pickupPhone2">
         <label for="edit-pickupPhone2">Phone2</label>
     </div>
  </div>
     -->

          <div class="ui-g-12 mt-4">
            <div class="text-right">
              <button
                type="button"
                pButton
                icon="fa ui-icon-check"
                label="Save"
                class="ui-button green-btn btn-to-right"
                (click)="saveContactDetails()"
                [disabled]="pickupForm?.invalid"
              ></button>
              <button
                type="button"
                (click)="setChangePickupDialog(false)"
                pButton
                icon="fa ui-icon-close"
                label="Cancel"
                class="ui-button btn-to-right"
              ></button>
            </div>
          </div>
        </div>
      </form>
    </p-dialog>

    <p-dialog
      header="Drop-off Contact Details"
      [(visible)]="dropoffContactEdit"
      [responsive]="true"
      [style]="{ width: '500px' }"
      [modal]="true"
    >
      <form [formGroup]="dropoffForm">
        <div class="ui-g" style="position: relative" *ngIf="selectedTask">
          <div class="ui-g-6 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-dropoffForename"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.dropoffForename"
                formControlName="dropoffForename"
                class="w-100"
              />
              <label for="edit-dropoffForename">Forename</label>
            </div>
          </div>

          <div class="ui-g-6 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-dropoffSurname"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.dropoffSurname"
                formControlName="dropoffSurname"
                class="w-100"
              />
              <label for="edit-dropoffSurname">Surname</label>
            </div>
          </div>

          <div class="ui-g-12 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-dropoffEmail"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.dropoffEmail"
                formControlName="dropoffEmail"
                class="w-100"
              />
              <label for="edit-dropoffEmail">Email</label>
            </div>
            <div *ngIf="dropoffForm?.controls?.dropoffEmail?.errors?.email" class="text-danger">
              A valid email address is required
            </div>
          </div>

          <div class="ui-g-12 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-dropoffSecondaryEmail"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.dropoffSecondaryEmail"
                formControlName="dropoffSecondaryEmail"
                class="w-100"
              />
              <label for="edit-dropoffSecondaryEmail">Secondary Email</label>
            </div>
            <div
              *ngIf="dropoffForm?.controls?.dropoffSecondaryEmail?.errors?.email"
              class="text-danger"
            >
              A valid email address is required
            </div>
          </div>

          <div class="ui-g-6 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-dropoffPhone1"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.dropoffPhone1"
                formControlName="dropoffPhone1"
                class="w-100"
              />
              <label for="edit-dropoffPhone1">Mobile Number</label>
            </div>
            <div *ngIf="dropoffPhone1Error != ''" class="text-danger">
              {{ dropoffPhone1Error }}
            </div>
          </div>

          <div class="ui-g-6 mt-4">
            <div class="ui-float-label">
              <input
                id="edit-dropoffPhone2"
                type="text"
                pInputText
                [(ngModel)]="selectedTask.dropoffPhone2"
                formControlName="dropoffPhone2"
                class="w-100"
              />
              <label for="edit-dropoffPhone2">Phone Number (alternative)</label>
            </div>
            <div *ngIf="dropoffPhone2Error != ''" class="text-danger">
              {{ dropoffPhone2Error }}
            </div>
          </div>

          <!-- in case they decide we need 2 phone fields
  <div class="ui-g-12">
     <div class="ui-float-label u-g-12">
         <input id="edit-dropoffPhone2" type="text" pInputText [(ngModel)]="selectedTask.dropoffPhone2">
         <label for="edit-dropoffPhone2">Phone2</label>
     </div>
  </div>
     -->

          <div class="ui-g-12 mt-4">
            <div class="text-right">
              <button
                type="button"
                pButton
                icon="fa ui-icon-check"
                label="Save"
                class="ui-button green-btn btn-to-right"
                (click)="saveContactDetails()"
                [disabled]="dropoffForm?.invalid"
              ></button>
              <button
                type="button"
                (click)="setChangeDropoffDialog(false)"
                pButton
                icon="fa ui-icon-close"
                label="Cancel"
                class="ui-button btn-to-right"
              ></button>
            </div>
          </div>
        </div>
      </form>
    </p-dialog>

    <p-dialog
      header="Direct To Supplier"
      [(visible)]="isShowChangeSupplierDetails"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '500px' }"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <div class="ui-g-4">
            <label>Operational Zone</label>
          </div>
          <div class="ui-g-8">
            <p-multiSelect
              [options]="eregions"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedERegions"
              (onChange)="onERegionChange($event)"
              name="eregions"
            ></p-multiSelect>
            <!--<p-dropdown [options]="suppliers" placeholder="Select account code"
           [disabled]="searchingSuppliers" autoWidth="false" [style]="{'width':'100%'}"
           [(ngModel)]="selectedSupplier" filter="filter"></p-dropdown>-->
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-4">
            <label>Suppliers</label>
          </div>
          <div class="ui-g-8">
            <p-multiSelect
              [options]="esuppliers"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedESuppliers"
              name="status"
            ></p-multiSelect>
            <!--<p-dropdown [options]="suppliers" placeholder="Select account code"
                [disabled]="searchingSuppliers" autoWidth="false" [style]="{'width':'100%'}"
                [(ngModel)]="selectedSupplier" filter="filter"></p-dropdown>-->
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-4">
            <label>SMS Text</label>
          </div>
          <div class="ui-g-8">
            <textarea pInputTextarea rows="7" [(ngModel)]="smsText" style="width: 100%"></textarea>
          </div>
        </div>

        <div style="width: 100%; height: 40px">
          <button
            type="button"
            (click)="CancelChangeSupplierDetails()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Send SMS"
            [disabled]="!(selectedERegions.length > 0 && selectedESuppliers.length > 0 && smsText)"
            class="ui-button green-btn btn-to-right"
            (click)="SaveChangeSupplierDetails()"
          ></button>
        </div>
        <div
          style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: gray;
            opacity: 0.3;
          "
          *ngIf="searchingSuppliers || isBusyChangeSupplierDetails"
        >
          <img
            src="assets/images/loader.gif"
            style="margin-left: 45%; margin-top: 10%"
            width="50"
            height="50"
            alt="load"
          />
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="Change Supplier Price/Account"
      [(visible)]="isShowChangeSupplierPriceAccount"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '350px' }"
    >
      <div class="ui-g" style="position: relative; height: 250px">
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Account code</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="accountCodes"
              placeholder="Select account code"
              [disabled]="searchingAccountCodes"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedAccountCode"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Region</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="regions"
              [disabled]="searchingRegions"
              placeholder="Select region"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedRegion"
              (onChange)="regionChanged($event)"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Depot</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="depots"
              placeholder="Select depot"
              [disabled]="!selectedRegion || searchingDepots"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedDepot"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12" *ngIf="organisationTypeId == 1">
          <div class="ui-grid-col-4">
            <label>Supplier Price</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              type="number"
              name="supplierPrice"
              pInputText
              style="width: 100%"
              [(ngModel)]="supplierPrice"
              id="supplierPrice"
            />
          </div>
        </div>
        <div class="ui-g-12" *ngIf="organisationTypeId == 1">
          <div class="ui-grid-col-4">
            <label>Tags</label>
          </div>
          <div class="ui-grid-col-8">
            <p-multiSelect
              [options]="jobTags"
              [(ngModel)]="selectedJobTags"
              [panelStyle]="{ minWidth: '12em' }"
              [style]="{ width: '100%' }"
              defaultLabel="Please Select"
            ></p-multiSelect>
          </div>
        </div>

        <div style="width: 100%; height: 40px">
          <button
            type="button"
            (click)="CancelChangeSupplierPriceAccount()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
            (click)="SaveChangeSupplierPriceAccount()"
          ></button>
        </div>
        <div
          style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: gray;
            opacity: 0.3;
          "
          *ngIf="
            searchingAccountCodes ||
            searchingRegions ||
            searchingDepots ||
            isBusyChangeSupplierPriceAccount ||
            searchingTags
          "
        >
          <img
            src="assets/images/loader.gif"
            style="margin-left: 45%; margin-top: 10%"
            width="50"
            height="50"
            alt="load"
          />
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="Change Driver/Truck"
      [(visible)]="isShowChangeDriverTruck"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '350px' }"
    >
      <div class="ui-g" style="position: relative; height: 250px; word-wrap: break-word">
        <div class="ui-g-12">
          <div class="ui-grid-col-2">
            <label>Driver</label>
          </div>
          <div class="ui-grid-col-10">
            <p-dropdown
              [options]="drivers"
              placeholder="Select Driver"
              [disabled]="searchingDrivers"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedDriver"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-2">
            <label>Truck</label>
          </div>
          <div class="ui-grid-col-10">
            <p-dropdown
              [options]="trucks"
              placeholder="Select Truck"
              [disabled]="searchingTrucks"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedTruck"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>
        <div style="width: 100%; height: 40px">
          <button
            type="button"
            (click)="closeChangeDriverTruck()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
            (click)="SaveChangeDriverTruck()"
            [disabled]="isDriverEqual(selectedDriver) && isTruckEqual(selectedTruck)"
          ></button>
        </div>
        <div
          style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: gray;
            opacity: 0.3;
          "
          *ngIf="searchingDrivers || searchingTrucks || isBusyChangeDriverTruck"
        >
          <img
            src="assets/images/loader.gif"
            style="margin-left: 45%; margin-top: 10%"
            width="50"
            height="50"
            alt="load"
          />
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="New Message"
      [(visible)]="isSendMessageToDriver"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '350px' }"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <textarea
            pInputTextarea
            [(ngModel)]="smsMessage"
            [rows]="3"
            [cols]="35"
            [maxlength]="250"
          ></textarea>
        </div>
        <div style="width: 100%; height: 40px">
          <button
            type="button"
            (click)="closeSendMessageToDriver()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Send"
            class="ui-button green-btn btn-to-right"
            (click)="sendMessageToDriver()"
            [disabled]="smsMessage.trim().length == 0"
          ></button>
        </div>
        <div
          style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: gray;
            opacity: 0.3;
          "
          *ngIf="isBusySendMessageToDriver"
        >
          <img
            src="assets/images/loader.gif"
            style="margin-left: 45%; margin-top: 10%"
            width="50"
            height="50"
            alt="load"
          />
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="Change Job Details"
      [(visible)]="isShowChangeJobDetails"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '500px' }"
      styleClass="overflow-dialog"
    >
      <form [formGroup]="jobDetailsForm">
        <div class="ui-g" style="position: relative">
          <div class="ui-g-12">
            <div class="ui-grid-col-6">
              <label>Existing capacity end date</label>
            </div>
            <div class="ui-grid-col-6">
              <p-calendar
                [(ngModel)]="exisingCapacityEndDate"
                [showTime]="true"
                name="exisingCapacityEndDate"
                styleClass="full-width-calendar"
                dateFormat="D d MM"
                hourFormat="24"
                [disabled]="!(exisingCapacityEndDate > currentDate())"
                formControlName="exisingCapacityEndDate"
              ></p-calendar>
              <div
                *ngIf="
                  !jobDetailsForm.controls['exisingCapacityEndDate'].valid &&
                  jobDetailsForm.controls['exisingCapacityEndDate'].dirty &&
                  jobDetailsForm.controls['exisingCapacityEndDate'].errors &&
                  jobDetailsForm.controls['exisingCapacityEndDate'].errors.error
                "
                class="ui-messages-error ui-corner-all"
                style="padding: 0.25em 0.5em"
              >
                {{ jobDetailsForm.controls['exisingCapacityEndDate'].errors.error }}
              </div>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-6">
              <label>Released from hold date</label>
            </div>
            <div class="ui-grid-col-6">
              <p-calendar
                [(ngModel)]="heldEndDate"
                [showTime]="true"
                name="heldEndDate"
                styleClass="full-width-calendar"
                dateFormat="D d MM"
                hourFormat="24"
                formControlName="heldEndDate"
              ></p-calendar>
              <div
                *ngIf="
                  !jobDetailsForm.controls['heldEndDate'].valid &&
                  jobDetailsForm.controls['heldEndDate'].dirty &&
                  jobDetailsForm.controls['heldEndDate'].errors &&
                  jobDetailsForm.controls['heldEndDate'].errors.error
                "
                class="ui-messages-error ui-corner-all"
                style="padding: 0.25em 0.5em"
              >
                {{ jobDetailsForm.controls['heldEndDate'].errors.error }}
              </div>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-6">
              <label>Grab it now opens date</label>
            </div>
            <div class="ui-grid-col-6">
              <p-calendar
                [(ngModel)]="exisingCapacityEndDate"
                [showTime]="true"
                name="exisingCapacityEndDate"
                styleClass="full-width-calendar"
                dateFormat="D d MM"
                hourFormat="24"
                [disabled]="!(exisingCapacityEndDate < jobInfoEarliestPickUpTime)"
                formControlName="buyNowOpensDate"
              ></p-calendar>
              <div
                *ngIf="
                  !jobDetailsForm.controls['buyNowOpensDate'].valid &&
                  jobDetailsForm.controls['buyNowOpensDate'].dirty &&
                  jobDetailsForm.controls['buyNowOpensDate'].errors &&
                  jobDetailsForm.controls['buyNowOpensDate'].errors.error
                "
                class="ui-messages-error ui-corner-all"
                style="padding: 0.25em 0.5em"
              >
                {{ jobDetailsForm.controls['buyNowOpensDate'].errors.error }}
              </div>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-6">
              <label>Scheduled Date</label>
            </div>
            <div class="ui-grid-col-6">
              <p-calendar
                [(ngModel)]="scheduledDate"
                [showTime]="false"
                name="scheduledDate"
                styleClass="full-width-calendar"
                dateFormat="D d MM"
                hourFormat="24"
                formControlName="scheduledDate"
              ></p-calendar>
              <div
                *ngIf="
                  !jobDetailsForm.controls['scheduledDate'].valid &&
                  jobDetailsForm.controls['scheduledDate'].dirty &&
                  jobDetailsForm.controls['scheduledDate'].errors &&
                  jobDetailsForm.controls['scheduledDate'].errors.error
                "
                class="ui-messages-error ui-corner-all"
                style="padding: 0.25em 0.5em"
              >
                {{ jobDetailsForm.controls['scheduledDate'].errors.error }}
              </div>
            </div>
          </div>

          <div class="ui-g-12">
            <div class="ui-grid-col-6">
              <label>Grab it now price</label>
            </div>
            <div class="ui-grid-col-6">
              <input
                name="buyItNowPrice"
                [(ngModel)]="buyItNowPrice"
                [style]="{ width: '100%' }"
                pInputText
                maxlength="10"
                (keydown)="inputHelper.allowNumberInputKey($event)"
                (keyup)="inputHelper.fixDigits($event.target)"
                formControlName="buyItNowPrice"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-6">
              <label>Existing capacity price</label>
            </div>
            <div class="ui-grid-col-6">
              <input
                name="existingCapacityPrice"
                [(ngModel)]="existingCapacityPrice"
                [style]="{ width: '100%' }"
                pInputText
                maxlength="10"
                (keydown)="inputHelper.allowNumberInputKey($event)"
                (keyup)="inputHelper.fixDigits($event.target)"
                formControlName="existingCapacityPrice"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-6">
              <label>Supplier Paid</label>
            </div>
            <div class="ui-grid-col-6">
              <input
                name="supplierPrice"
                [(ngModel)]="supplierPrice"
                [style]="{ width: '100%' }"
                pInputText
                maxlength="10"
                (keydown)="inputHelper.allowNumberInputKey($event)"
                (keyup)="inputHelper.fixDigits($event.target)"
                formControlName="supplierPrice"
              />
            </div>
          </div>

          <div *ngIf="jobInfo && !jobInfo.isSelfInsured" class="ui-g-12">
            <div class="ui-grid-col-6">
              <label>Insurance Provider</label>
            </div>
            <div class="ui-grid-col-6">
              <p-dropdown
                name="insuranceProviders"
                [options]="insuranceProviders"
                autoWidth="false"
                [style]="{ width: '100%' }"
                [(ngModel)]="insuranceProviderId"
                formControlName="insuranceProviderId"
              ></p-dropdown>
            </div>
          </div>

          <div *ngIf="jobInfo && !jobInfo.isSelfInsured" class="ui-g-12">
            <div class="ui-grid-col-6">
              <label>Insurance Cost</label>
            </div>
            <div class="ui-grid-col-6">
              <input
                name="insuranceCost"
                [(ngModel)]="insuranceCost"
                [style]="{ width: '100%' }"
                pInputText
                maxlength="10"
                (keydown)="inputHelper.allowNumberInputKey($event)"
                (keyup)="inputHelper.fixDigits($event.target)"
                formControlName="insuranceCost"
              />
            </div>
          </div>

          <div style="width: 100%; height: 40px; margin-top: 20px">
            <button
              type="button"
              (click)="cancelChangeJobDetails()"
              pButton
              icon="fa ui-icon-close"
              label="Cancel"
              class="ui-button btn-to-right"
            ></button>
            <button
              type="button"
              pButton
              icon="fa ui-icon-check"
              label="Save"
              [disabled]="!changeJobDetailsValid() || jobDetailsForm.invalid"
              class="ui-button green-btn btn-to-right"
              (click)="saveChangeJobDetails()"
            ></button>
          </div>
          <div
            style="
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              background: gray;
              opacity: 0.3;
            "
            *ngIf="isBusyChangeJobDetails"
          >
            <img
              src="assets/images/loader.gif"
              style="margin-left: 45%; margin-top: 10%"
              width="50"
              height="50"
              alt="load"
            />
          </div>
        </div>
      </form>
    </p-dialog>

    <p-dialog
      header="Add Driver Note"
      [(visible)]="isShowAddDriverNotes"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '400px' }"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Note Type</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="noteTypes"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="newNoteIsPickup"
            ></p-dropdown>
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Driver Note</label>
          </div>
          <div class="ui-grid-col-8">
            <textarea
              pInputTextarea
              [(ngModel)]="newNoteDescription"
              [rows]="3"
              [cols]="30"
              [maxlength]="250"
              placeholder="Add here"
            ></textarea>
          </div>
        </div>

        <div style="width: 100%; height: 40px">
          <button
            type="button"
            (click)="closeAddDriverNotes()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
            (click)="saveAddDriverNotes()"
            [disabled]="newNoteDescription.trim().length == 0"
          ></button>
        </div>
        <div
          style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: gray;
            opacity: 0.3;
          "
          *ngIf="isBusyAddDriverNotes"
        >
          <img
            src="assets/images/loader.gif"
            style="margin-left: 45%; margin-top: 10%"
            width="50"
            height="50"
            alt="load"
          />
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="Edit Order"
      [(visible)]="isShowEditOrder"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '400px' }"
      (onHide)="closeEditOrder()"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Account code</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="accountCodes"
              placeholder="Select account code"
              [disabled]="
                searchingAccountCodes ||
                jobInfo?.statusId == jobStatus_Closed ||
                organisationId !== 1
              "
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedAccountCode"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Department</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="customerDepartments"
              placeholder="Select order department"
              optionLabel="name"
              dataKey="id"
              [disabled]="searchingOrderDepartments || isCustomerInvoiced || organisationId !== 1"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedOrderDepartment"
              (onChange)="departmentChange($event)"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>

        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Team</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="departmentTeams"
              placeholder="Select order Team"
              optionLabel="name"
              dataKey="id"
              [disabled]="
                searchingDepartmentTeams ||
                searchingOrderDepartments ||
                isCustomerInvoiced ||
                organisationId !== 1
              "
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedOrderTeam"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>

        <div class="ui-g-12" *ngIf="organisationTypeId == 1 || organisationTypeId == 2">
          <div class="ui-grid-col-4">
            <label>Purchase Number</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              type="text"
              name="purchaseOrderNo"
              pInputText
              style="width: 100%"
              [disabled]="isCustomerInvoiced"
              [(ngModel)]="purchaseOrderNo"
              id="purchaseOrderNo"
              maxlength="50"
            />
          </div>
        </div>

        <div class="ui-g-12" *ngIf="organisationTypeId == 1">
          <div class="ui-grid-col-4">
            <label>Customer Price</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              type="number"
              name="orderCustomerPrice"
              pInputText
              style="width: 100%"
              [disabled]="jobInfo?.statusId == jobStatus_Closed || selectedOrder?.isOverridePrice"
              [(ngModel)]="orderCustomerPrice"
              id="orderCustomerPrice"
            />
          </div>
        </div>

        <div class="ui-g-12" *ngIf="organisationTypeId == 1 && orderShowInspectionCharge">
          <div class="ui-grid-col-4">
            <label>Inspection Charge</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              type="number"
              name="orderInspectionCharge"
              pInputText
              style="width: 100%"
              [disabled]="jobInfo?.statusId == jobStatus_Closed"
              [(ngModel)]="orderInspectionCharge"
              id="orderInspectionCharge"
            />
          </div>
        </div>

        <div class="ui-g-12" *ngIf="organisationTypeId == 1 || organisationTypeId == 2">
          <div class="ui-grid-col-4">
            <label>Tags</label>
          </div>
          <div class="ui-grid-col-8">
            <p-multiSelect
              [options]="orderTags"
              [(ngModel)]="selectedOrderTags"
              [panelStyle]="{ minWidth: '12em' }"
              [style]="{ width: '100%' }"
              defaultLabel="Please Select"
              [disabled]="organisationId !== 1"
            ></p-multiSelect>
          </div>
        </div>

        <div class="ui-g-12" *ngIf="organisationTypeId == 1">
          <div class="ui-grid-col-4">
            <label>Fix Customer Price</label>
          </div>
          <div class="ui-grid-col-8">
            <p-checkbox
              binary="true"
              name="isOverridePrice"
              [disabled]="jobInfo?.statusId == jobStatus_Closed"
              [(ngModel)]="isOverridePrice"
              id="isOverridePrice"
            ></p-checkbox>
          </div>
        </div>
        <div class="ui-g-12" *ngIf="organisationTypeId == 1">
          <div class="ui-grid-col-4">Cancellation Status</div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="cancellationStatuses"
              autoWidth="false"
              [style]="{ width: '100%' }"
              (onChange)="showSubCancellationStatusIfApplicable()"
              [(ngModel)]="cancellationStatusId"
            >
              <ng-template let-data pTemplate="selectedItem">
                <div title="{{ data.tag.description }}">
                  {{ data.label }}
                </div>
              </ng-template>
              <ng-template let-data pTemplate="item">
                <div title="{{ data.tag.description }}">
                  {{ data.label }}
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <div
          *ngIf="organisationTypeId == 1 && toDisplaySecondaryCancellation"
          class="ui-g"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <div class="ui-grid-col-4">Secondary cancellation status</div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="secondaryCancellationStatuses"
              (onChange)="onSecondaryCancellationStatusChange()"
              autoWidth="false"
              appendTo="body"
              [style]="{ width: '100%' }"
              [(ngModel)]="secondaryCancellationStatusId"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="ui-g-12" *ngIf="organisationTypeId == 1">
          <div class="ui-grid-col-4">Why are you cancelling this order?</div>
          <div class="ui-grid-col-8">
            <textarea
              [(ngModel)]="cancellationDescription"
              style="width: 100%"
              pInputTextarea
              [rows]="8"
            ></textarea>
          </div>
        </div>
        <div style="width: 100%; height: 40px; margin-top: 20px">
          <button
            type="button"
            (click)="closeEditOrder()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
            (click)="saveEditOrder()"
          ></button>
        </div>
        <div
          style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: gray;
            opacity: 0.3;
          "
          *ngIf="isBusyEditOrder || searchOrderTags || searchingAccountCodes"
        >
          <img
            src="assets/images/loader.gif"
            style="margin-left: 45%; margin-top: 10%"
            width="50"
            height="50"
            alt="load"
          />
        </div>
      </div>
    </p-dialog>

    <p-dialog
      [header]="isShowAddPhotoToTaskStep ? 'Add Photo to Step' : 'Update Photo Data'"
      [(visible)]="isAddEditPhotoDialogVisible"
      [responsive]="true"
      [modal]="true"
      (onHide)="closeAddPhotoToTaskStep()"
      [style]="{ width: '450px' }"
    >
      <div class="ui-g" style="position: relative">
        <div
          class="ui-g-12"
          *ngIf="!selectedCompleteTaskStep"
          style="font-size: 0.9em; font-style: italic; text-align: center"
        >
          Before you can upload a photo this step must be marked as completed in driver checklist.
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Area</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="areas"
              placeholder="Select area"
              [disabled]="!selectedCompleteTaskStep"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedArea"
              filter="filter"
              (onChange)="onAreaChange()"
            ></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Description</label>
          </div>
          <div class="ui-grid-col-8">
            <textarea
              maxlength="250"
              style="width: 100%"
              pInputTextarea
              [(ngModel)]="addPhotoDescription"
            ></textarea>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Condition</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="conditions"
              placeholder="Select condition"
              (onChange)="onConditionChange($event)"
              [disabled]="!selectedCompleteTaskStep"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedCondition"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>

        <div *ngIf="selectedCondition != 0 && selectedCondition != 4" class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Condition Comment</label>
          </div>
          <div class="ui-grid-col-8">
            <textarea
              pInputTextarea
              rows="3"
              [(ngModel)]="conditionComment"
              style="width: 100%"
              maxlength="250"
            ></textarea>
          </div>
        </div>
        <div *ngIf="isShowAddPhotoToTaskStep" class="ui-g-12">
          <div class="ui-grid-col-4">&nbsp;</div>
          <div class="ui-grid-col-8">
            <div style="margin-left: -5px">
              <p-fileUpload
                name="files"
                multiple="true"
                url="/api/filestorage/multiplefileuploading"
                (onProgress)="progressUploading($event)"
                (onBeforeUpload)="onBeforeUpload($event)"
                (onSelect)="onSelect($event)"
                (onError)="onError($event)"
                (onUpload)="onMultipleFileUpload($event)"
                withCredentials="true"
                [maxFileSize]="83886080"
                accept="application/pdf,image/*,.heic"
                auto="true"
                chooseLabel="Upload Photo"
                mode="basic"
              ></p-fileUpload>
            </div>
            <li *ngFor="let uploadResult of multipleFileUploadResult" class="list-group-item">
              <div class="uploaded-photo" [ngSwitch]="uploadResult.fileData.extension">
                <i *ngSwitchCase="'pdf'" class="fa fa-file-pdf-o pdf-icon" aria-hidden="true"></i>
                <img
                  *ngSwitchDefault
                  [src]="uploadResult.presignedUrl"
                  class="ui-galleria-frame-image"
                  width="60"
                  height="40"
                />
                <div class="filename">{{ uploadResult?.fileData?.name }}</div>
                <div *ngIf="uploadResult?.errorMessage">{{ uploadResult.errorMessage }}</div>
              </div>
            </li>
          </div>
        </div>

        <div class="ui-g-12" style="height: 40px; margin-top: 20px">
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            [label]="isShowAddPhotoToTaskStep ? 'Save Photo' : 'Update Photo'"
            class="ui-button green-btn btn-to-right"
            (click)="saveMultiplePhotosOnStep()"
            [disabled]="
              !selectedCompleteTaskStep ||
              (!selectedImage && multipleFileUploadResult?.length <= 0) ||
              !selectedCompleteTaskStep ||
              (!selectedArea && !selectedArea == null) ||
              selectedCondition == null ||
              !isConditionCommentValid()
            "
          ></button>

          <button
            type="button"
            (click)="closeAddPhotoToTaskStep()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
        </div>
        <div
          style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: gray;
            opacity: 0.3;
          "
          *ngIf="isBusyAddPhotoToStep || isBusyUploadImage"
        >
          <img
            src="assets/images/loader.gif"
            style="margin-left: 45%; margin-top: 10%"
            width="50"
            height="50"
            alt="load"
          />
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="Set Area Condition"
      [(visible)]="isShowSetAreaCondition"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '450px' }"
    >
      <div class="ui-g" style="position: relative">
        <div
          class="ui-g-12"
          *ngIf="!selectedCompleteTaskStep"
          style="font-size: 0.9em; font-style: italic; text-align: center"
        >
          Before you can set condition this step must be marked as completed in driver checklist.
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Area</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="areas"
              placeholder="Select area"
              [disabled]="!selectedCompleteTaskStep"
              autoWidth="false"
              [style]="{ width: '100%' }"
              (onChange)="onAreaChange()"
              [(ngModel)]="selectedArea"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Condition</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="conditions"
              placeholder="Select condition"
              (onChange)="onConditionChange($event)"
              [disabled]="!selectedCompleteTaskStep"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedCondition"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>

        <div *ngIf="selectedCondition != 0 && selectedCondition != 4" class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Comment</label>
          </div>
          <div class="ui-grid-col-8">
            <textarea
              pInputTextarea
              rows="3"
              [(ngModel)]="conditionComment"
              style="width: 100%"
              maxlength="250"
            ></textarea>
          </div>
        </div>

        <div class="ui-g-12" style="height: 40px; margin-top: 20px">
          <button
            type="button"
            (click)="closeSetAreaCondition()"
            pButton
            icon="fa ui-icon-close"
            label="Close"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Set Condition"
            class="ui-button green-btn btn-to-right"
            (click)="setAreacCondition()"
            [disabled]="
              !selectedCompleteTaskStep ||
              (!selectedArea && !selectedArea == null) ||
              selectedCondition == null ||
              !isConditionCommentValid()
            "
          ></button>
        </div>
        <div
          style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: gray;
            opacity: 0.3;
          "
          *ngIf="isBusySetAreaCondition"
        >
          <img
            src="assets/images/loader.gif"
            style="margin-left: 45%; margin-top: 10%"
            width="50"
            height="50"
            alt="load"
          />
        </div>
      </div>
    </p-dialog>

    <p-dialog
      [header]="
        cancelAction == cancelOrderAction_CustomerHoursAtWhichCap1Charged
          ? 'Abort Order'
          : 'Cancel Order'
      "
      [(visible)]="showCancelOrderDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '400px' }"
    >
      <div class="ui-grid-row ui-grid-responsive ui-fluid">
        <span *ngIf="cancelAction != cancelOrderAction_CancelNoFee">
          Do you want to abort this order, you will be charged £{{
            customerChargedPrice | number : '1.2-2'
          }}?
        </span>
        <span *ngIf="cancelAction == cancelOrderAction_CancelNoFee">
          Do you want to cancel this order?
        </span>
        <!--<span *ngIf="cancelAction == cancelOrderAction_Cancel3Fee || cancelAction == cancelOrderAction_Cancel7Fee">
            Do you want to cancel this order, you will be charged £{{cancelChargedPrice| number:'1.2-2'}}?
        </span>-->
      </div>

      <div
        class="ui-grid-row ui-grid-responsive ui-fluid"
        style="margin-top: 10px; margin-bottom: 10px"
      >
        <div class="ui-grid-col-4">Why are you cancelling this order?</div>
        <div class="ui-grid-col-8">
          <textarea
            [(ngModel)]="cancellationDescription"
            [style]="{ width: '100%' }"
            pInputTextarea
            [rows]="3"
            autofocus
          ></textarea>
        </div>
      </div>

      <div class="ui-grid-row" style="margin-top: 20px">
        <button
          type="button"
          (click)="showCancelOrderDialog = false"
          pButton
          icon="fa ui-icon-close"
          label="Close"
          class="ui-button btn-to-right"
        ></button>
        <button
          type="button"
          pButton
          [disabled]="!cancellationDescription"
          (click)="cancelOrderConfirm()"
          [label]="
            cancelAction == cancelOrderAction_CustomerHoursAtWhichCap1Charged
              ? 'Abort Order'
              : 'Cancel Order'
          "
          class="ui-button red-btn btn-to-right"
        ></button>
      </div>
    </p-dialog>

    <p-dialog
      header="Cancel Job"
      [(visible)]="showCancelJobDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '400px' }"
    >
      <div class="ui-grid-row ui-grid-responsive ui-fluid">
        <span *ngIf="cancelAction != cancelJobAction_Cancel3Warn">
          Do you want to cancel this job?
        </span>
        <span *ngIf="cancelAction == cancelJobAction_Cancel3Warn">
          Do you want to cancel this job?
          <br />
          Please note that cancelling at this short notice will count against you for future work.
        </span>
      </div>

      <div
        class="ui-grid-row ui-grid-responsive ui-fluid"
        style="margin-top: 10px; margin-bottom: 10px"
      >
        <div class="ui-grid-col-4">Why are you cancelling this job?</div>
        <div class="ui-grid-col-8">
          <textarea
            [(ngModel)]="cancellationDescription"
            [style]="{ width: '100%' }"
            pInputTextarea
            [rows]="3"
            autofocus
          ></textarea>
        </div>
      </div>

      <div class="ui-grid-row" style="margin-top: 20px">
        <button
          type="button"
          (click)="showCancelJobDialog = false"
          pButton
          icon="fa ui-icon-close"
          label="Close"
          class="ui-button btn-to-right"
        ></button>
        <button
          type="button"
          (click)="cancelJobConfirm()"
          pButton
          label="Cancel Job"
          [disabled]="!cancellationDescription"
          class="ui-button red-btn btn-to-right"
        ></button>
      </div>
    </p-dialog>

    <p-dialog
      [header]="
        cancelAction == cancelOrderAction_CustomerHoursAtWhichCap1Charged
          ? 'Abort Order'
          : 'Cancel Order'
      "
      [(visible)]="showCancelOrderVmeDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '500px' }"
      (onHide)="closeCancelJobOrder()"
    >
      <div style="position: relative; overflow-y: auto">
        <div class="ui-g">
          <span>
            This action will cancel/abort the order. The standard fee for this is £{{
              customerChargedPrice | number : '1.2-2'
            }}
            do you want to apply this or not?
          </span>
        </div>

        <div class="ui-g" style="margin-top: 10px; margin-bottom: 10px">
          <div class="ui-grid-col-4">Supplier payment</div>
          <div class="ui-grid-col-4">
            <!--<p-spinner [(ngModel)]="newCustomerChargedPrice" [step]="0.01"></p-spinner>-->
            <input
              [(ngModel)]="newSupplierChargedPrice"
              [style]="{ width: '100%' }"
              pInputText
              maxlength="10"
              (keydown)="inputHelper.allowNumberInputKey($event)"
              (keyup)="inputHelper.fixDigitsAndMax($event.target, 10000)"
            />
          </div>
        </div>

        <div class="ui-g" style="margin-top: 10px; margin-bottom: 10px">
          <div class="ui-grid-col-4">Cancellation charge</div>
          <div class="ui-grid-col-4">
            <!--<p-spinner [(ngModel)]="newCustomerChargedPrice" [step]="0.01"></p-spinner>-->
            <input
              [(ngModel)]="newCustomerChargedPrice"
              [style]="{ width: '100%' }"
              pInputText
              maxlength="10"
              (keydown)="inputHelper.allowNumberInputKey($event)"
              (keyup)="inputHelper.fixDigitsAndMax($event.target, 10000)"
            />
          </div>
        </div>

        <div
          *ngIf="organisationTypeId == 1"
          class="ui-g"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <div class="ui-grid-col-4">Cancellation status</div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="cancellationStatuses"
              appendTo="body"
              autoWidth="false"
              [style]="{ width: '100%' }"
              (onChange)="showSubCancellationStatusIfApplicable()"
              [(ngModel)]="cancellationStatusId"
            >
              <ng-template let-data pTemplate="selectedItem">
                <div title="{{ data.tag.description }}">
                  {{ data.label }}
                </div>
              </ng-template>
              <ng-template let-data pTemplate="item">
                <div title="{{ data.tag.description }}">
                  {{ data.label }}
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>

        <div
          *ngIf="organisationTypeId == 1 && toDisplaySecondaryCancellation"
          class="ui-g"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <div class="ui-grid-col-4">Secondary cancellation status</div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="secondaryCancellationStatuses"
              (onChange)="onSecondaryCancellationStatusChange()"
              autoWidth="false"
              appendTo="body"
              [style]="{ width: '100%' }"
              [(ngModel)]="secondaryCancellationStatusId"
            >
            </p-dropdown>
          </div>
        </div>

        <div class="ui-g" style="margin-top: 10px; margin-bottom: 10px">
          <div class="ui-grid-col-4">Why are you cancelling this order?</div>
          <div class="ui-grid-col-8">
            <textarea
              [(ngModel)]="cancellationDescription"
              [style]="{ width: '100%' }"
              pInputTextarea
              [rows]="3"
            ></textarea>
          </div>
        </div>

        <!--<div
          *ngIf="toDisplaySecondaryCancellationStatusDescription"
          class="ui-g"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <div class="ui-grid-col-4">Why are you cancelling this order (2nd reason)?</div>
          <div class="ui-grid-col-8">
            <textarea
              [(ngModel)]="secondaryCancellationDescription"
              [style]="{ width: '100%' }"
              pInputTextarea
              [rows]="3"
            ></textarea>
          </div>
        </div>-->
      </div>
      <p-footer>
        <button
          type="button"
          (click)="closeCancelJobOrder()"
          pButton
          icon="fa ui-icon-close"
          label="Close"
          class="ui-button btn-to-right"
        ></button>

        <button
          type="button"
          (click)="cancelJobOrder(true)"
          pButton
          [disabled]="
            !cancellationDescription || !cancellationStatusId || !hasSelectedSecondaryStatus()
          "
          [label]="
            cancelAction == cancelOrderAction_CustomerHoursAtWhichCap1Charged
              ? 'Abort With Fee'
              : 'Cancel With Fee'
          "
          class="ui-button red-btn btn-to-right"
        ></button>
        <button
          type="button"
          (click)="cancelJobOrder(false)"
          pButton
          [disabled]="
            !cancellationDescription || !cancellationStatusId || !hasSelectedSecondaryStatus()
          "
          [label]="
            cancelAction == cancelOrderAction_CustomerHoursAtWhichCap1Charged
              ? 'Abort Without Fee'
              : 'Cancel Without Fee'
          "
          class="ui-button green-btn btn-to-right"
        ></button>
      </p-footer>
    </p-dialog>

    <p-dialog
      header="Cancel Job"
      [(visible)]="showCancelJobVmeDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '500px' }"
    >
      <div class="ui-grid-row ui-grid-responsive ui-fluid">
        <span>
          This action will cancel the job. The standard fee for this is £{{
            cancelChargedPrice | number : '1.2-2'
          }}
          do you want to apply this or not?
        </span>
      </div>

      <div
        class="ui-grid-row ui-grid-responsive ui-fluid"
        style="margin-top: 10px; margin-bottom: 10px"
      >
        <div class="ui-grid-col-2">Change Fee</div>
        <div class="ui-grid-col-4">
          <p-spinner [(ngModel)]="cancelChargedPrice" [step]="0.01"></p-spinner>
        </div>
      </div>

      <div
        class="ui-grid-row ui-grid-responsive ui-fluid"
        style="margin-top: 10px; margin-bottom: 10px"
      >
        <div class="ui-grid-col-4">Why are you cancelling this job?</div>
        <div class="ui-grid-col-8">
          <textarea
            [(ngModel)]="cancellationDescription"
            [style]="{ width: '100%' }"
            pInputTextarea
            [rows]="3"
            autofocus
          ></textarea>
        </div>
      </div>

      <div class="ui-grid-row" style="margin-top: 20px">
        <button
          type="button"
          (click)="closeCancelJobOrder()"
          pButton
          icon="fa ui-icon-close"
          label="Close"
          class="ui-button btn-to-right"
        ></button>

        <button
          type="button"
          (click)="cancelJobOrder(false)"
          pButton
          label="Cancel Without Fee"
          [disabled]="!cancellationDescription"
          class="ui-button green-btn btn-to-right"
        ></button>
        <button
          type="button"
          (click)="cancelJobOrder(true)"
          pButton
          label="Cancel With Fee"
          [disabled]="!cancellationDescription"
          class="ui-button red-btn btn-to-right"
        ></button>
      </div>
    </p-dialog>

    <p-dialog
      *ngIf="selectedTask"
      header="Edit Locations"
      [(visible)]="showEditLocationsDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '900px' }"
    >
      <div class="ui-g-12"></div>
      <div class="ui-grid-row" style="margin-top: 20px">
        <button
          type="button"
          (click)="showEditLocationsDialog = false"
          pButton
          icon="fa ui-icon-close"
          label="Close"
          class="ui-button btn-to-right"
        ></button>
        <button
          type="button"
          (click)="editLocationsConfirm()"
          pButton
          label="Save"
          icon="fa ui-icon-check"
          class="ui-button green-btn btn-to-right"
        ></button>
      </div>
    </p-dialog>

    <p-dialog
      header="Impersonate Supplier"
      [(visible)]="showImpersonateSupplierDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '450px' }"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>User</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="impersonateSupplierUsers"
              placeholder="Select user"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedImpersonateUser"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>

        <div class="ui-g-12" style="margin-top: 20px">
          <button
            type="button"
            (click)="showImpersonateSupplierDialog = false"
            pButton
            icon="fa ui-icon-close"
            label="Close"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Impersonate"
            class="ui-button green-btn btn-to-right"
            (click)="impersonateSupplierConfirm()"
            [disabled]="!selectedImpersonateUser"
          ></button>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="Impersonate Customer"
      [(visible)]="showImpersonateCustomerDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '450px' }"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>User</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="impersonateCustomerUsers"
              placeholder="Select user"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedImpersonateUser"
              appendTo="body"
              filter="filter"
            ></p-dropdown>
          </div>
        </div>

        <div class="ui-g-12" style="margin-top: 20px">
          <button
            type="button"
            (click)="showImpersonateCustomerDialog = false"
            pButton
            icon="fa ui-icon-close"
            label="Close"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Impersonate"
            class="ui-button green-btn btn-to-right"
            (click)="impersonateCustomerConfirm()"
            [disabled]="!selectedImpersonateUser"
          ></button>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="Change Late Statuses"
      [(visible)]="isShownLateStatusesDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '500px' }"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Pick-up Late Status</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="lateStatusesSelectItems"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="lateStatusesEdited.pickupLateStatusId"
            ></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Pick-up Late Reason</label>
          </div>
          <div class="ui-grid-col-8">
            <textarea
              pInputTextarea
              [(ngModel)]="lateStatusesEdited.pickupLateReason"
              [rows]="2"
              [maxlength]="250"
              style="width: 100%"
            ></textarea>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Drop-off Late Status</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="lateStatusesSelectItems"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="lateStatusesEdited.dropoffLateStatusId"
            ></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Drop-off Late Reason</label>
          </div>
          <div class="ui-grid-col-8">
            <textarea
              pInputTextarea
              [(ngModel)]="lateStatusesEdited.dropoffLateReason"
              [rows]="2"
              [maxlength]="250"
              style="width: 100%"
            ></textarea>
          </div>
        </div>
        <div class="ui-g-12" style="margin-top: 20px">
          <button
            type="button"
            (click)="isShownLateStatusesDialog = false"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
            [disabled]="lateReasonsValid"
            (click)="saveLateStatuses()"
          ></button>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="MoDel PIN"
      [(visible)]="isShownMoDelPin"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '350px' }"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <input
            [(ngModel)]="moDelPin"
            maxlength="7"
            style="width: 100%"
            (keydown)="inputHelper.allowNumberInputKey($event, false)"
            (keyup)="inputHelper.fixDigits($event.target)"
            pInputText
          />
        </div>
        <div class="ui-g-12" style="margin-top: 20px">
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
            (click)="saveMoDelPin()"
          ></button>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="Release Code"
      [(visible)]="isShownReleaseCode"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '350px' }"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <input [(ngModel)]="releaseCode" style="width: 100%" pInputText />
        </div>
        <div class="ui-g-12" style="margin-top: 20px">
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
            (click)="saveReleaseCode()"
          ></button>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      [header]="(odometerEdited.isPickup ? 'Pick-Up' : 'Drop-Off') + ' Odometer Reading'"
      [(visible)]="isShownOdometerDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '350px' }"
    >
      <div class="ui-g" style="position: relative">
        <div class="ui-g-12">
          <input
            type="number"
            [(ngModel)]="odometerEdited.odometer"
            style="width: 100%"
            pInputText
            maxlength="7"
            min="0"
            max="9999999"
          />
          <div
            *ngIf="editedOdometerIsDropoffLessPickup"
            class="ui-messages-error ui-corner-all"
            style="padding: 0.25em 0.5em"
          >
            Drop-off odometer reading needs to be greater than pick-up reading
          </div>
        </div>
        <div class="ui-g-12" style="margin-top: 20px">
          <button
            type="button"
            (click)="isShownOdometerDialog = false"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button btn-to-right"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button green-btn btn-to-right"
            [disabled]="!editedOdometerValid"
            (click)="saveOdometerReading()"
          ></button>
        </div>
      </div>
    </p-dialog>

    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="isBusy"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 10%"
        width="50"
        height="50"
        alt="load"
      />
    </div>

    <p-blockUI [blocked]="loadingPopupPhoto || isShownPopupPhoto">
      <img
        *ngIf="loadingPopupPhoto"
        src="assets/images/loader.gif"
        style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%)"
        width="50"
        height="50"
        alt="load"
      />
    </p-blockUI>
    <img
      *ngIf="isShownPopupPhoto"
      [src]="popupPhotoUrl"
      style="
        z-index: 10000;
        max-height: 90%;
        max-width: 90%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    />
  </div>
</div>

<p-dialog
  header="Edit Actual Movement Type"
  [(visible)]="showEditActualTaskTypeDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div class="ui-g-4" style="padding-top: 20px">Customer Movement Type:</div>
      <div class="ui-g-8">
        <p-dropdown
          name="taskTypes"
          [options]="taskTypes"
          placeholder="Select task type"
          autoWidth="false"
          [style]="{ width: '100%' }"
          [(ngModel)]="taskTypeId"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4" style="padding-top: 20px">Engineius Movement Type:</div>
      <div class="ui-g-8">
        <p-dropdown
          name="taskTypes"
          [options]="taskTypes"
          placeholder="Select task type"
          autoWidth="false"
          [style]="{ width: '100%' }"
          [(ngModel)]="actualTaskTypeId"
        ></p-dropdown>
      </div>
    </div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row" style="float: right; margin-bottom: 10px">
    <button
      type="button"
      class="green-btn"
      pButton
      icon="fa ui-icon-check"
      (click)="confirmMultiOrderTaskType()"
      label="Save"
      [disabled]="!actualTaskTypeId && !taskTypeId"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="showEditActualTaskTypeDialog = false"
    ></button>
  </div>
</p-dialog>

<p-dialog
  header="Edit Reg Status"
  [(visible)]="showEditRegStatusDialog"
  [responsive]="true"
  blockScroll="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div class="ui-g-4" style="padding-top: 20px">Status:</div>
      <div class="ui-g-8">
        <p-dropdown
          name="regStatuses"
          [options]="regStatuses"
          placeholder="Select status"
          autoWidth="false"
          [style]="{ width: '100%' }"
          [(ngModel)]="regStatusId"
          appendTo="body"
        ></p-dropdown>
      </div>
    </div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row" style="float: right; margin-bottom: 10px">
    <button
      type="button"
      class="green-btn"
      pButton
      icon="fa ui-icon-check"
      (click)="saveRegStatus()"
      label="Save"
      [disabled]="!regStatusId"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="showEditRegStatusDialog = false"
    ></button>
  </div>
</p-dialog>

<p-dialog
  header="Edit Trade Plate"
  [(visible)]="showEditTradePlateDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div class="ui-g-4" style="padding-top: 20px">Trade Plate Number:</div>
      <div class="ui-g-8">
        <input
          name="tradePlateNumber"
          pInputText
          id="tradePlateNumber"
          [(ngModel)]="tradePlateNumber"
          maxlength="6"
        />
      </div>
    </div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row" style="float: right; margin-bottom: 10px">
    <button
      type="button"
      class="green-btn"
      pButton
      icon="fa ui-icon-check"
      (click)="saveTradePlate()"
      label="Save"
      [disabled]="!isTradePlateValid(tradePlateNumber)"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="showEditTradePlateDialog = false"
    ></button>
  </div>
</p-dialog>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  width="425"
  acceptLabel="Confirm"
  rejectLabel="Cancel"
></p-confirmDialog>

<p-confirmDialog #cd key="allocate-driver" closable="false" [style]="{ width: '425px' }">
  <p-footer>
    <button type="button" pButton label="No" (click)="cd.reject()"></button>
    <button type="button" pButton class="ui-button" label="Yes" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-dialog
  header="Pause Reason"
  [(visible)]="showPauseReasonDialog"
  [style]="{ width: '500px' }"
  [modal]="true"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div class="ui-g-6">
        <strong> Please select a reason: </strong>
      </div>
      <div class="ui-g-6">
        <p-dropdown
          appendTo="body"
          name="pauseReason"
          placeholder="Please select a reason"
          [options]="pauseReasons"
          [(ngModel)]="pauseReasonId"
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-grid-row pull-right mt-4">
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="showPauseReasonDialog = false"
      ></button>
      <button
        type="button"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        (click)="pauseResumeTask()"
        label="Done"
      ></button>
    </div>
  </div>
</p-dialog>

<ng-template #checklist_steps_template let-checklistSteps="steps">
  <ul class="list-group">
    <li *ngFor="let step of checklistSteps" class="list-group-item">
      <div class="ui-g-12 step-name">
        <div class="d-flex">
          <div class="flex-grow-1">
            <p-checkbox
              [(ngModel)]="step.isComplete"
              [label]="step.content"
              binary="true"
              [disabled]="
                !isDriverChecklistManualEdit ||
                jobInfo?.statusId == jobStatus_Paused ||
                step.isPauseStep
              "
              (onChange)="taskStepCheckChanged(step)"
            ></p-checkbox>
          </div>

          <div
            class="flex-shrink-1"
            *ngIf="step.date && step.latitude && step.longitude"
            (click)="handleShowCurrentLocation(step)"
          >
            <span class="fa fa-map-marker link fa-15x"></span>
          </div>
        </div>

        <div *ngIf="step == stepCalendar">
          <p-calendar
            [(ngModel)]="step.date"
            [showTime]="true"
            [showOnFocus]="true"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            appendTo="body"
            utc="true"
            (ngModelChange)="onDriverChecklistChanged(step)"
          >
          </p-calendar>
        </div>
      </div>

      <div
        *ngIf="step.taskOrganisationSpecificStep?.organisationSpecificStep?.description?.length > 0"
        class="ui-g-12"
      >
        <div>
          <div class="description-field" id="stepDescription-{{ step.id }}">
            {{ step.taskOrganisationSpecificStep?.organisationSpecificStep?.description }}
          </div>
        </div>
      </div>

      <div class="mt-1">
        <small *ngIf="step.date" class="small-date-text">{{
          step.date | datex : "ddd DD MMM 'YY HH:mm"
        }}</small>
      </div>

      <div *ngIf="isDriverChecklistManualEdit && step.taskOrganisationSpecificStep?.id">
        <ng-container
          *ngTemplateOutlet="
            editOrgSpecStepTemplate;
            context: {
              orgStep: step.taskOrganisationSpecificStep?.organisationSpecificStep,
              taskStep: step.taskOrganisationSpecificStep
            }
          "
        ></ng-container>
      </div>

      <div class="clearfix"></div>

      <div class="uploaded-photos" *ngIf="!isDriverChecklistManualEdit">
        <div *ngFor="let tsp of step.taskOrganisationSpecificStep?.stepPhotos">
          <span
            class="fa fa-image fa-2x cursor-pointer"
            style="display: inline-block; vertical-align: bottom"
            (click)="previewChecklistPhoto(tsp, step.taskOrganisationSpecificStep)"
          ></span>
        </div>
      </div>

      <div class="clearfix"></div>

      <div *ngIf="step?.taskOrganisationSpecificStep && !isDriverChecklistManualEdit" class="pl-2">
        <div
          class="ui-g-12"
          *ngIf="step?.taskOrganisationSpecificStep?.comment && step.showDetails"
        >
          {{ step?.taskOrganisationSpecificStep?.comment }}
        </div>

        <div>
          <div class="flex-grow-1" *ngIf="step.taskOrganisationSpecificStep?.ancillaryStepId">
            <div
              class="d-flex"
              [style]="{ 'padding-top': '0px', 'padding-bottom': '0px', 'margin-bottom': '10px' }"
            >
              <div>Ancilliary Steps</div>
              <div style="margin-bottom: 7px; margin-left: 2px">
                {{ step.taskOrganisationSpecificStep?.ancillaryStep?.stepName }}
              </div>
            </div>
          </div>

          <div class="flex-grow-1" *ngIf="step?.taskOrganisationSpecificStep?.answers?.length">
            <div
              class="step-answer-div"
              [style]="{ 'padding-top': '0px', 'padding-bottom': '0px', 'margin-bottom': '10px' }"
            >
              <div>Response</div>
              <div *ngIf="step.showDetails">
                <div
                  *ngFor="let answer of step.taskOrganisationSpecificStep.answers"
                  class="ui-g-12"
                >
                  <div class="ui-g-12">
                    <p-checkbox
                      binary="true"
                      [(ngModel)]="answer.isSelected"
                      [ngModelOptions]="{ standalone: true }"
                      name="isSelected"
                      label="{{ answer.answer?.text }}"
                      [disabled]="true"
                    ></p-checkbox>
                    <div *ngIf="answer.responseTime">
                      <small *ngIf="answer.responseTime" class="small-date-text">{{
                        answer.responseTime | datex : "ddd DD MMM 'YY HH:mm"
                      }}</small>
                    </div>
                  </div>
                  <div *ngIf="answer.uninspected" class="ui-g-12">Uninspected</div>
                  <div *ngIf="answer.answerMedia && answer.answerMedia.length > 0">
                    <div *ngFor="let answerMedia of answer.answerMedia" class="ui-g-4">
                      <a href="{{ answerMedia.photoLocation }}" target="_blank"
                        ><img
                          src="{{ answerMedia.photoLocation }}"
                          style="max-height: 100%; max-width: 100%"
                          alt=""
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="flex-shrink-1"
            *ngIf="
              step.taskOrganisationSpecificStep?.answers?.length > 0 ||
              step?.taskOrganisationSpecificStep?.comment
            "
          >
            <span
              class="fa link"
              style="color: #999"
              [ngClass]="step.showDetails ? 'fa-chevron-up' : 'fa-chevron-down'"
              (click)="toggleStepDetail(step)"
            ></span>
          </div>
        </div>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #editOrgSpecStepTemplate let-orgStep="orgStep" let-taskStep="taskStep">
  <div style="padding-left: 27px">
    <div *ngIf="orgStep?.minPhotosAllowed != null" class="ui-g-12 mb-2" style="margin-left: -8px">
      <p-button
        label="Add"
        icon="fa fa-camera"
        (click)="initChecklistStepPhotosDialog(taskStep)"
      ></p-button>

      <span *ngFor="let tsp of taskStep.stepPhotos">
        &nbsp;
        <span
          class="fa fa-image fa-2x cursor-pointer"
          style="display: inline-block; vertical-align: bottom"
          (click)="previewChecklistPhoto(tsp, taskStep)"
        ></span>
      </span>
    </div>

    <div *ngIf="orgStep?.allowFreeText" class="ui-g-12 mb-2">
      <input
        [placeholder]="orgStep?.placeholderText || orgStep?.description"
        pInputText
        (change)="commentChange($event, taskStep)"
        [(ngModel)]="editAnswers[taskStep.id]['comment']"
      />
      <label for="text-{{ orgStep.id }}"></label>
    </div>

    <div *ngIf="orgStep?.isQuestion" class="ui-g-12">
      <div *ngFor="let answertemp of taskStep?.answers" style="margin-bottom: 5px">
        <p-checkbox
          binary="true"
          [(ngModel)]="editAnswers[taskStep.id][answertemp.id]['isSelected']"
          (onChange)="checkboxChange($event, answertemp.id, taskStep)"
        ></p-checkbox>

        {{ answertemp?.answer?.text }}

        <span *ngIf="answertemp.allowPhotos">
          -
          <span
            class="add-photo-to-answer"
            (click)="initChecklistStepAnswerPhotosDialog(taskStep, answertemp)"
            >Add Photo</span
          >

          <span *ngFor="let am of answertemp.answerMedia">
            &nbsp;
            <i
              class="fa fa-photo cursor-pointer"
              (click)="previewChecklistAnswerPhoto(am, taskStep)"
            ></i>
          </span>
        </span>
      </div>
    </div>
  </div>
</ng-template>

<p-dialog
  *ngIf="selectedStepPhotos"
  header="Step Photos"
  [(visible)]="showStepPhotosDialog"
  [style]="{ width: '500px' }"
  [modal]="true"
  closable="true"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div *ngFor="let photo of selectedStepPhotos">
      <img src="{{ photo }}" height="150px" width="150px" alt="" />
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Custom Step Answer Photo"
  [(visible)]="showPreviewChecklistAnswerPhoto"
  [style]="{ width: '500px' }"
  [modal]="true"
  closable="true"
>
  <div class="ui-grid ui-grid-responsive">
    <div class="text-center">
      <a target="_blank" href="{{ selectedImage?.photoLocation }}"
        ><img src="{{ selectedImage?.photoLocation }}" height="150px" width="150px" alt=""
      /></a>
    </div>
    <div class="text-right mt-2 p-2" style="min-height: 50px">
      <button
        pButton
        class="ui-button pull-right"
        icon="fa fa-check"
        label="Close"
        (click)="showPreviewChecklistAnswerPhoto = false"
      ></button>
      &nbsp;
      <button
        pButton
        class="ui-button-danger ui-button pull-right"
        icon="fa fa-trash"
        label="Delete"
        (click)="deleteChecklistAnswerPhoto(selectedImage)"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Custom Step Photo"
  [(visible)]="showPreviewChecklistPhoto"
  [style]="{ width: '800px' }"
  [modal]="true"
  closable="true"
>
  <div class="ui-grid ui-grid-responsive">
    <div class="text-center">
      <a href="{{ selectedImage?.photoLocation }}" target="_blank">
        <img src="{{ selectedImage?.photoLocation }}" height="350px" width="350px" alt="" />
      </a>
    </div>
    <div class="text-right mt-2 p-2" style="min-height: 50px">
      <button
        pButton
        class="ui-button-danger ui-button pull-right"
        icon="fa fa-trash"
        label="Delete"
        (click)="deleteChecklistPhoto(selectedImage)"
      ></button>
      <button
        pButton
        icon="fa fa-check"
        class="ui-button pull-right"
        label="Close"
        (click)="showPreviewChecklistPhoto = false"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Step Photos"
  [(visible)]="showChecklistStepPhotosDialog"
  [style]="{ width: '500px' }"
  [modal]="true"
  closable="true"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="p-2">
      <div *ngIf="selectedImage">
        <div *ngFor="let photo of selectedStepPhotos">
          <img src="{{ photo }}" height="150px" width="150px" alt="" />
        </div>

        <div class="uploaded-photo" *ngIf="selectedImage">
          <img
            [src]="selectedImageSource"
            class="ui-galleria-frame-image"
            width="60"
            height="50"
            alt=""
          />
          <div class="filename">{{ selectedImage.name }}</div>
        </div>
      </div>

      <p-fileUpload
        *ngIf="!selectedImage"
        name="files"
        url="/api/filestorage/fileuploading"
        (onProgress)="progressUploading($event)"
        (onBeforeUpload)="onBeforeUpload($event)"
        (onSelect)="onSelect($event)"
        (onError)="onError($event)"
        (onUpload)="onUpload($event)"
        withCredentials="true"
        [maxFileSize]="83886080"
        accept="application/pdf,image/*,.heic"
        auto="true"
        [chooseLabel]="'Upload Photo'"
        mode="basic"
      ></p-fileUpload>

      <div class="pt-2 pb-2" style="min-height: 50px">
        <button
          type="button"
          pButton
          icon="fa ui-icon-check"
          [label]="'Save Photo'"
          class="ui-button green-btn btn-to-right"
          (click)="savePhotoOnOrgSpecificStep()"
          [disabled]="!selectedImage"
        ></button>

        <button
          type="button"
          (click)="showChecklistStepPhotosDialog = false"
          pButton
          icon="fa ui-icon-close"
          label="Cancel"
          class="ui-button btn-to-right"
        ></button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Step Answer Photos"
  [(visible)]="showChecklistStepAnswerPhotosDialog"
  [style]="{ width: '500px' }"
  [modal]="true"
  closable="true"
>
  <div class="p-2">
    <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="!selectedImage">
      <p-fileUpload
        name="files"
        url="/api/filestorage/fileuploading"
        (onProgress)="progressUploading($event)"
        (onBeforeUpload)="onBeforeUpload($event)"
        (onSelect)="onSelect($event)"
        (onError)="onError($event)"
        (onUpload)="onUpload($event)"
        withCredentials="true"
        [maxFileSize]="83886080"
        accept="application/pdf,image/*,.heic"
        auto="true"
        [chooseLabel]="'Upload Photo'"
        mode="basic"
      ></p-fileUpload>
    </div>

    <div class="uploaded-photo" *ngIf="selectedImage">
      <img
        [src]="selectedImageSource"
        class="ui-galleria-frame-image"
        width="60"
        height="50"
        alt=""
      />
      <div class="filename">{{ selectedImage.name }}</div>
    </div>

    <div class="pt-2 pb-2" style="min-height: 50px">
      <button
        type="button"
        pButton
        icon="fa ui-icon-check"
        [label]="'Save Photo'"
        class="ui-button green-btn btn-to-right"
        (click)="savePhotoOnOrgSpecificStepAnswer()"
        [disabled]="!selectedImage"
      ></button>

      <button
        type="button"
        (click)="showChecklistStepAnswerPhotosDialog = false"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        class="ui-button btn-to-right"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Current Location"
  [(visible)]="showCurrentLocationDialog"
  [style]="{ width: '500px' }"
  [modal]="true"
  closable="true"
  *ngIf="selectedStep"
>
  <map-control [readOnlyMode]="true" [(origin)]="currentLocation"></map-control>
</p-dialog>

<p-dialog
  [(visible)]="showRemoveConfirm"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <p-header>Reason for Unassigning</p-header>

  <div class="p-2">
    <div class="ui-g">
      <div class="ui-g-3 text-right">Reason</div>
      <div class="ui-g-9">
        <p-dropdown
          appendTo="body"
          placeholder="Select a Reason"
          [options]="unassignReasons"
          [(ngModel)]="unassignReasonId"
          autoWidth="false"
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g">
      <div class="ui-g-3 text-right">Comment</div>
      <div class="ui-g-9 pl-2">
        <textarea
          pInputTextarea
          [(ngModel)]="unassignComment"
          class="w-full"
          style="height: 100px"
        ></textarea>
      </div>
    </div>

    <div class="ui-g">
      <div class="ui-g-3">&nbsp;</div>

      <div class="ui-g-9 text-right">
        <button pButton class="" (click)="showRemoveConfirm = false" label="Cancel"></button>
        <button
          pButton
          class="ui-button-success"
          label="Confirm"
          (click)="confirmRemoveFromSupplier()"
          [disabled]="unassignReasonId == null"
        ></button>
      </div>
    </div>
  </div>
</p-dialog>

<ng-template #previousSuppliers let-jobInfo="jobInfo">
  <span
    *ngIf="
      organisationTypeId == organisationTypeEnum.Engineius &&
      previousAssignments(jobInfo).length > 0
    "
  >
    <button
      pButton
      label="Previously assigned"
      (click)="showPreviousSuppliers = !showPreviousSuppliers"
    ></button>
    <div *ngIf="showPreviousSuppliers" class="mt-2">
      <table class="table-striped unassigned-table">
        <thead>
          <tr>
            <th class="align-left">Date Unassigned</th>
            <th class="align-left">Supplier</th>
            <th class="align-left">Unassigned Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let previous of previousAssignments(jobInfo)">
            <td>{{ previous?.jobUnassignedDate | datex : "ddd DD MMM 'YY HH:mm" }}</td>
            <td>{{ previous?.supplier.name }}</td>
            <td>{{ previous?.jobUnassignedReason.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </span>
</ng-template>

<!--<p-dialog-->
<!--  header="Allocate Job"-->
<!--  [(visible)]="showAllocateJobDialog"-->
<!--  [modal]="true"-->
<!--  [responsive]="true"-->
<!--  [style]="{ 'max-width': '450px' }"-->
<!--&gt;-->
<!--  <div class="grid">-->
<!--    <div class="col-12" *ngIf="allocationSupplierCard">-->
<!--      <supplier-card [data]="allocationSupplierCard"></supplier-card>-->
<!--    </div>-->

<!--    <div class="tags-container col-12">-->
<!--      <div style="display: flex; flex-direction: row; align-items: center; justify-content: right">-->
<!--        <span class="ui-dialog-content">Supplier Tags:</span>-->
<!--        <div *ngFor="let tag of allocationSupplierCard?.supplierTags">-->
<!--          <div class="tag-name">{{ tag?.tagEntity?.name }}</div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div style="display: flex; flex-direction: row; align-items: center; justify-content: right">-->
<!--        <span class="ui-dialog-content">Required Tags:</span>-->
<!--        <div *ngFor="let tag of allocationSupplierCard?.requiredTags">-->
<!--          <div *ngFor="let tagE of tag.tags">-->
<!--            <div class="tag-name">{{ tagE?.tagEntity?.name }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="grid">-->
<!--      <div class="col-4">Price (£)</div>-->
<!--      <div class="col-8">-->
<!--        <input-->
<!--          *ngIf="jobInfo"-->
<!--          type="number"-->
<!--          name="price"-->
<!--          autoWidth="false"-->
<!--          pInputText-->
<!--          [style]="{ width: '100%' }"-->
<!--          [(ngModel)]="allocationPrice"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="grid" style="float: right; margin-bottom: 10px">-->
<!--    <button-->
<!--      type="button"-->
<!--      class="green-btn"-->
<!--      pButton-->
<!--      icon="fa ui-icon-check"-->
<!--      (click)="allocateJobToSupplier()"-->
<!--      label="Allocate"-->
<!--    ></button>-->
<!--    <button-->
<!--      type="button"-->
<!--      pButton-->
<!--      icon="fa ui-icon-close"-->
<!--      label="Close"-->
<!--      (click)="showAllocateJobDialog = false"-->
<!--    ></button>-->
<!--  </div>-->
<!--</p-dialog>-->

<p-dialog
  header="Validation Result"
  [(visible)]="showValidationResult"
  [modal]="true"
  [style]="{ width: '860px' }"
  closable="true"
  *ngIf="organisationTypeId == 1 && selectedAdditionalCharge"
>
  <div *ngIf="!selectedAdditionalCharge.additionalExpenseValidations.length">
    No Validation information yet
  </div>

  <p-tabView *ngIf="selectedAdditionalCharge.additionalExpenseValidations.length">
    <p-tabPanel header="Validation">
      <table class="table-striped unassigned-table">
        <thead>
          <tr>
            <th class="align-left">Date and Time</th>
            <th class="align-left">Type</th>
            <th class="align-left">Status</th>
            <th class="align-left">Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let validation of selectedAdditionalCharge.additionalExpenseValidations">
            <td>
              {{ validation?.modifiedOn || validation?.createdOn | datex : "ddd DD MMM 'YY HH:mm" }}
            </td>
            <td>{{ validation?.validationType?.name | camelToSentenceCase }}</td>
            <td>{{ validation?.validationStatus?.name | camelToSentenceCase }}</td>
            <td>{{ validation?.comment }}</td>
          </tr>
        </tbody>
      </table>
    </p-tabPanel>
    <p-tabPanel header="Analysis">
      <table class="table-striped unassigned-table">
        <thead>
          <tr>
            <th class="align-left">Name</th>
            <th class="align-left">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Vendor Name</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.vendorName }}</td>
          </tr>
          <tr></tr>
          <tr>
            <td>Receipt ID</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.receiptId }}</td>
          </tr>
          <tr>
            <td>Receipt Date and Time</td>
            <td>
              {{
                selectedAdditionalCharge.additionalExpenseAnalysis?.receiptDateTime
                  | datex : "ddd DD MMM 'YY HH:mm"
              }}
            </td>
          </tr>
          <tr>
            <td>Address Line</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.addressLine }}</td>
          </tr>
          <tr>
            <td>Post Code</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.postCode }}</td>
          </tr>
          <tr>
            <td>City</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.city }}</td>
          </tr>
          <tr>
            <td>Country</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.country }}</td>
          </tr>
          <tr>
            <td>Sub-Total</td>
            <td>
              {{
                selectedAdditionalCharge.additionalExpenseAnalysis?.subTotal
                  | currency : 'GBP' : 'symbol' : '1.2-2'
              }}
            </td>
          </tr>
          <tr>
            <td>Tax</td>
            <td>
              {{
                selectedAdditionalCharge.additionalExpenseAnalysis?.tax
                  | currency : 'GBP' : 'symbol' : '1.2-2'
              }}
            </td>
          </tr>
          <tr>
            <td>Total Amount</td>
            <td>
              {{
                selectedAdditionalCharge.additionalExpenseAnalysis?.totalAmount
                  | currency : 'GBP' : 'symbol' : '1.2-2'
              }}
            </td>
          </tr>
          <tr *ngIf="selectedAdditionalCharge.chargingTimeDuration">
            <td>Charging Time Duration</td>
            <td>
              <span *ngIf="selectedAdditionalCharge.started && selectedAdditionalCharge.ended"
                ><b>Started:</b>
                {{ selectedAdditionalCharge.started | datex : "ddd DD MMM 'YY HH:mm:ss" }} |
                <b>Ended:</b>
                {{ selectedAdditionalCharge.ended | datex : "ddd DD MMM 'YY HH:mm:ss" }}</span
              >
              | <b>Total:</b>
              {{ formatChargingWaitingDuration(selectedAdditionalCharge.chargingTimeDuration) }} |
              <b>ProRated</b>
              {{
                formatChargingWaitingDuration(
                  selectedAdditionalCharge?.proRatedChargingTimeDuration
                )
              }}
            </td>
          </tr>
          <tr *ngIf="selectedAdditionalCharge.waitingTimeDuration">
            <td>Waiting Time Duration</td>
            <td>
              <span *ngIf="selectedAdditionalCharge.started && selectedAdditionalCharge.ended"
                ><b>Started:</b>
                {{ selectedAdditionalCharge.started | datex : "ddd DD MMM 'YY HH:mm:ss" }} |
                <b>Ended:</b>
                {{ selectedAdditionalCharge.ended | datex : "ddd DD MMM 'YY HH:mm:ss" }}</span
              >
              | <b>Total:</b>
              {{ formatChargingWaitingDuration(selectedAdditionalCharge.waitingTimeDuration) }} |
              <b>ProRated</b>
              {{
                formatChargingWaitingDuration(selectedAdditionalCharge.proRatedWaitingTimeDuration)
              }}
            </td>
          </tr>
          <tr>
            <td>VRN</td>
            <td>{{ selectedAdditionalCharge.additionalExpenseAnalysis?.vrn }}</td>
          </tr>
        </tbody>
      </table>
    </p-tabPanel>
  </p-tabView>
</p-dialog>

<edit-task-schedule-dialog
  *ngIf="selectedTask"
  [(visible)]="editTaskScheduleVisible"
  [jobId]="jobId"
  [taskId]="selectedTask.id"
  (scheduleUpdated)="onScheduleUpdated()"
  referrPage="jobScreen"
  [taskScheduleSource]="
    organisationTypeId == 1
      ? TaskSupplierScheduleSource.EngineiusEdit
      : TaskSupplierScheduleSource.SupplierEdit
  "
></edit-task-schedule-dialog>

<decline-additional-charge
  *ngIf="showRejectionDialog"
  [(visible)]="showRejectionDialog"
  (confirmDeclineCharge)="declineAdditionalCharge(selectedAdditionalCharge)"
  [additionalCharge]="selectedAdditionalCharge"
>
</decline-additional-charge>

<view-odometer-image-dialog
  *ngIf="odometerImageSource"
  [(visible)]="showOdometerImage"
  [imageSource]="odometerImageSource"
  (visibleChange)="odometerDialogVisibleChanged($event)"
>
</view-odometer-image-dialog>

<decline-additional-charge
  *ngIf="showRejectionDialog"
  [(visible)]="showRejectionDialog"
  (confirmDeclineCharge)="declineAdditionalCharge(selectedAdditionalCharge)"
  [additionalCharge]="selectedAdditionalCharge"
>
</decline-additional-charge>

<request-additional-info
  *ngIf="showRequestInfoDialog"
  [(visible)]="showRequestInfoDialog"
  (requestInfoComplete)="updateIncidentSection()"
  [additionalCharge]="selectedAdditionalCharge"
>
</request-additional-info>

<ngx-gallery
  *ngIf="expenseImages.length > 0"
  [options]="expenseGalleryOptions"
  [images]="expenseImages"
  (previewClose)="onExpenseImagePreviewClose()"
></ngx-gallery>

<p-dialog
  header="Booking Info"
  [(visible)]="showBookingInfo"
  [modal]="true"
  [style]="{ width: '560px' }"
  closable="true"
>
  <div style="padding-bottom: 10px; font-weight: bold; font-size: 1.2rem">Order Created By</div>

  <div style="text-align: left; padding-bottom: 10px; font-weight: bold">
    <i class="fa fa-user"></i> &nbsp; {{ currentOrder?.user?.firstName }}
    {{ currentOrder?.user?.lastName }}
  </div>

  <div style="text-align: left; font-weight: bold">
    <i class="fa fa-phone"></i>
    <a href="tel:{{ currentOrder?.user?.phoneNumber }}">
      &nbsp; {{ currentOrder?.user?.phoneNumber }}</a
    >
  </div>

  <div style="text-align: left; padding-top: 10px; font-weight: bold">
    <i class="fa fa-envelope"></i> &nbsp;
    <a href="mailto:{{ currentOrder?.user?.email }}">{{ currentOrder?.user?.email }}</a>
  </div>

  <div
    *ngIf="currentOrder?.customerTeam?.primaryContactEmail"
    style="padding-top: 10px; font-weight: bold"
  >
    <i class="fa fa-envelope"></i><span>Primary Contact Email:</span> &nbsp;
    <a href="mailto:{{ currentOrder?.customerTeam?.primaryContactEmail }}">{{
      currentOrder?.customerTeam?.primaryContactEmail
    }}</a>
  </div>

  <div *ngIf="currentOrder?.customerTeam?.primaryContactEmail" style="font-weight: bold">
    <i class="fa fa-envelope"></i><span>Secondary Contact Email:</span>
    &nbsp;
    <a href="mailto:{{ currentOrder?.customerTeam?.secondaryContactEmail }}">{{
      currentOrder?.customerTeam?.secondaryContactEmail
    }}</a>
  </div>

  <!--<div style="padding-top: 15px; padding-bottom: 10px; font-weight: bold; font-size: 1.2rem">
    Customer
  </div>

  <div>
    <div style="padding-bottom: 10px">
      <i class="fa fa-building"></i> &nbsp; {{ currentOrder?.customer?.name }}
    </div>
    <div style="padding-bottom: 10px; font-weight: bold">
      <i class="fa fa-phone"></i> &nbsp;
      <a href="tel:{{ currentOrder?.customer?.phoneNumber }}">{{
        currentOrder?.customer?.phoneNumber
      }}</a>
    </div>
  </div>-->
</p-dialog>

<p-dialog
  header="View Inspection Handover Recording"
  [(visible)]="isViewInspectionRecordingVisible"
  [modal]="true"
  [style]="{ width: '1000px' }"
>
  <ng-container *ngIf="selectedMedia">
    <video
      [src]="selectedMedia.mediaURL"
      controls
      class="inspection-handover-video-player"
      controlsList="nodownload"
      preload="metadata"
    >
      Your browser does not support HTML5 video.
    </video>
  </ng-container>
</p-dialog>

<app-task-sequencing-editor
  *ngIf="taskSequenceEditorVisible"
  [(visible)]="taskSequenceEditorVisible"
  (saveTaskSequence)="taskSequenceUpdated()"
  [jobId]="jobId"
></app-task-sequencing-editor>
